<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="6"
                md="6"
                sm="6"
            >
                <h3>Check Items - {{ serviceProjectResponse.idFormatted }}</h3>
            </v-col>
            <v-col 
                cols="6"
                style="text-align: right;"
            >
                <v-chip
                    color="var(--color__main)"
                    outlined
                    dark
                >
                    {{ serviceProjectResponse.statusDescription }}
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <hr />
            </v-col>
        </v-row>

        <v-stepper 
            alt-labels
            v-model="steps"
            style="box-shadow: none;"
        >
            <v-layout align-center justify-center>
                <v-row style="display: contents !important;">
                    <v-col 
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                    >
                        <v-stepper-header
                            style="box-shadow: none"
                        >
                            <v-stepper-step
                                :complete="steps > 1"
                                step="1"
                            >
                                Check Items
                            </v-stepper-step>

                            <v-divider></v-divider>

                            <v-stepper-step
                                step="2"
                                style="min-width: 210px !important;"
                            >
                                Choose Drafting Team
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-col>
                </v-row>
            </v-layout>

            <v-stepper-items>

                <!-- STEP 1: CHECK ITEMS  -->
                <v-stepper-content step="1">

                    <v-expansion-panels popout>

                        <!-- SERVICE INFORMATIONS -->
                        <v-col
                            cols="12"
                        >                    
                            <JobInformation 
                                :id="serviceProjectResponse.idService"
                                :project="projectSelected"
                                :refreshJob="refreshJob"
                                :showProjects="false"
                                :showJobSummary="true"
                                :showButtonsCreateEditProject="false"
                                :showButtonsCreateEditVersion="false"
                                :showClassification="true"
                                :showDisabledClassification="false"
                                v-on:changeProject="updateProject"
                            />
                        </v-col>

                        <!-- SCOPE OF WORK -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-sitemap
                                            </v-icon>
                                            {{ titles.scopeOfWork }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>

                                    <v-row>

                                        <v-col
                                            cols="12"
                                        >

                                            <v-simple-table
                                                fixed-header
                                                style="cursor: pointer;"
                                            >
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">
                                                                Category
                                                            </th>
                                                            <th class="text-left">
                                                                Sub Category
                                                            </th>
                                                            <th class="text-left">
                                                                Product
                                                            </th>
                                                            <th>
                                                                Notes
                                                            </th>
                                                            <th class="text-right">
                                                                Qty
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            v-for="(item, index) in listProductSelecteds" :key="index"
                                                        >
                                                            <td>{{ item.categoryDescription }}</td>
                                                            <td>{{ item.subCategoryDescription }}</td>
                                                            <td>{{ item.productDescription }}</td>
                                                            <td>{{ item.note }}</td>
                                                            <td class="text-right">{{ item.qty }} <span style="font-size: 10px; font-weight: bold;">{{ item.unitySymbol }}</span></td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th class="text-left"></th>
                                                            <th class="text-left"></th>
                                                            <th class="text-left"></th>
                                                            <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                                Grand Total
                                                            </th>
                                                            <th class="text-right" style="color: var(--color__main); font-size: 20px;">
                                                                {{ grandTotal }}
                                                            </th>
                                                        </tr>
                                                    </tfoot>
                                                </template>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.scopeOfWorkType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.scopeOfWorkType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.scopeOfWorkType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.scopeOfWorkType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                right
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.scopeOfWorkNotes != null && serviceDraftingRequest.scopeOfWorkNotes != undefined && serviceDraftingRequest.scopeOfWorkNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.scopeOfWork, serviceDraftingRequest.scopeOfWorkNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- DETAILS -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-information-variant
                                            </v-icon>
                                            Details
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-if="surveyFile && surveyFile.id != 0"
                                            cols="12"
                                            lg="3"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, surveyFile.id, surveyFile.fileType, surveyFile.fileName)"
                                                    >
                                                        <v-card-title class="cardTitleDownload">
                                                            <label>Survey (PDF)</label>
                                                        </v-card-title>

                                                        <v-card-subtitle>
                                                            <span>{{ surveyFile.createdOn }} by {{ surveyFile.userName }}</span>
                                                        </v-card-subtitle>

                                                        <v-card-text>
                                                            <v-icon x-large>mdi mdi-file-download-outline</v-icon>
                                                            <span class="imageFileName">{{ surveyFile.fileName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                            
                                        </v-col>

                                        <v-col
                                            v-if="architecturalSitePlanFile && architecturalSitePlanFile.id != 0"
                                            cols="12"
                                            lg="3"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, architecturalSitePlanFile.id, architecturalSitePlanFile.fileType, architecturalSitePlanFile.fileName)"
                                                    >
                                                        <v-card-title class="cardTitleDownload">
                                                            <label>Architectural Site Plan  (PDF, CAD, DWG)</label>
                                                        </v-card-title>

                                                        <v-card-subtitle>
                                                            <span>{{ architecturalSitePlanFile.createdOn }} by {{ architecturalSitePlanFile.userName }}</span>
                                                        </v-card-subtitle>

                                                        <v-card-text>

                                                            <v-icon x-large>mdi mdi-file-download-outline</v-icon>
                                                            <span class="imageFileName">{{ architecturalSitePlanFile.fileName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                            
                                        </v-col>

                                        <v-col
                                            v-if="poolStudioDXFFile && poolStudioDXFFile.id != 0"
                                            cols="12"
                                            lg="3"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, poolStudioDXFFile.id, poolStudioDXFFile.fileType, poolStudioDXFFile.fileName)"
                                                    >
                                                        <v-card-title class="cardTitleDownload">
                                                            <label>Pool Studio File (DXF)</label>
                                                        </v-card-title>

                                                        <v-card-subtitle>
                                                            <span>{{ poolStudioDXFFile.createdOn }} by {{ poolStudioDXFFile.userName }}</span>
                                                        </v-card-subtitle>

                                                        <v-card-text>

                                                            <v-icon x-large>mdi mdi-file-download-outline</v-icon>
                                                            <span class="imageFileName">{{ poolStudioDXFFile.fileName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                            
                                        </v-col>

                                        <v-col
                                            v-if="poolStudioPDFFile && poolStudioPDFFile.id != 0"
                                            cols="12"
                                            lg="3"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, poolStudioPDFFile.id, poolStudioPDFFile.fileType, poolStudioPDFFile.fileName)"
                                                    >
                                                        <v-card-title class="cardTitleDownload">
                                                            <label>Pool Studio File (PDF)</label>
                                                        </v-card-title>

                                                        <v-card-subtitle>
                                                            <span>{{ poolStudioPDFFile.createdOn }} by {{ poolStudioPDFFile.userName }}</span>
                                                        </v-card-subtitle>

                                                        <v-card-text>

                                                            <v-icon x-large>mdi mdi-file-download-outline</v-icon>
                                                            <span class="imageFileName">{{ poolStudioPDFFile.fileName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                            
                                        </v-col>

                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.detailsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.detailsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.detailsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.detailsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.detailsNotes != null && serviceDraftingRequest.detailsNotes != undefined && serviceDraftingRequest.detailsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.details, serviceDraftingRequest.detailsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- EQUIPMENT LOCATION -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-arrow-split-vertical
                                            </v-icon>
                                            Equipment Location
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in dimensionedEquipmentLocationPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.dimensionedEquipmentLocationNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.dimensionedEquipmentLocationType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.dimensionedEquipmentLocationType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.dimensionedEquipmentLocationType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.dimensionedEquipmentLocationType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.dimensionedEquipmentLocationNotes != null && serviceDraftingRequest.dimensionedEquipmentLocationNotes != undefined && serviceDraftingRequest.dimensionedEquipmentLocationNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.dimensionedEquipmentLocation, serviceDraftingRequest.dimensionedEquipmentLocationNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- POOL BARRIER -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left style="margin-top: -6px;">
                                                mdi-fence
                                            </v-icon>
                                            Pool Barrier
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            lg="12"
                                            md="12"
                                            sm="12"
                                        >
                                            <label>Fence Type</label>
                                            <v-combobox
                                                v-model="fenceTypeSelected"
                                                :items="listFenceType"
                                                item-text="description"
                                                item-value="id"
                                                chips
                                                multiple
                                                clearable
                                                outlined
                                                disabled
                                                dense
                                            ></v-combobox>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.fenceEnclosureInformationType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.fenceEnclosureInformationType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.fenceEnclosureInformationType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.fenceEnclosureInformationType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.fenceEnclosureInformationNotes != null && serviceDraftingRequest.fenceEnclosureInformationNotes != undefined && serviceDraftingRequest.fenceEnclosureInformationNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.fenceEnclosureInformation, serviceDraftingRequest.fenceEnclosureInformationNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- FENCE LOCATION -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-fence-electric
                                            </v-icon>
                                            Fence Locations
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in fenceLocationPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.fenceLocationNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.fenceLocationType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.fenceLocationType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.fenceLocationType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.fenceLocationType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.fenceLocationNotes != null && serviceDraftingRequest.fenceLocationNotes != undefined && serviceDraftingRequest.fenceLocationNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.fenceLocation, serviceDraftingRequest.fenceLocationNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- DEPTH AND DEEPEST POINT DESIRED LOCATION -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-graph-outline
                                            </v-icon>
                                            Depth and Deepest Point Desired Location
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in depthDeepestPointLocationPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.depthDeepestPointLocationNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.depthDeepestPointLocationType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.depthDeepestPointLocationType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.depthDeepestPointLocationType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.depthDeepestPointLocationType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.depthDeepestPointLocationNotes != null && serviceDraftingRequest.depthDeepestPointLocationNotes != undefined && serviceDraftingRequest.depthDeepestPointLocationNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.depthDeepestPointLocation, serviceDraftingRequest.depthDeepestPointLocationNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- LIGHT LOCATION -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-lightbulb-question-outline
                                            </v-icon>
                                            Light Locations
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in lightLocationsPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.lightLocationsNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.lightLocationsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.lightLocationsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.lightLocationsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.lightLocationsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.lightLocationsNotes != null && serviceDraftingRequest.lightLocationsNotes != undefined && serviceDraftingRequest.lightLocationsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.lightLocations, serviceDraftingRequest.lightLocationsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- SOIL TEST -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-floor-plan
                                            </v-icon>
                                            Soil Test
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-if="soilTestFile && soilTestFile.id != 0"
                                            cols="12"
                                            lg="3"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, soilTestFile.id, soilTestFile.fileType, soilTestFile.fileName)"
                                                    >
                                                        <v-card-title class="cardTitleDownload">
                                                            <label>Soil Test (PDF)</label>
                                                        </v-card-title>

                                                        <v-card-subtitle>
                                                            <span>{{ soilTestFile.createdOn }} by {{ soilTestFile.userName }}</span>
                                                        </v-card-subtitle>

                                                        <v-card-text>
                                                            <v-icon x-large>mdi mdi-file-download-outline</v-icon>
                                                            <span class="imageFileName">{{ soilTestFile.fileName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                            
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.soilTestType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.soilTestType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.soilTestType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.soilTestType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.soilTestNotes != null && serviceDraftingRequest.soilTestNotes != undefined && serviceDraftingRequest.soilTestNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.soilTest, serviceDraftingRequest.soilTestNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- PERGOLAS -->
                        <v-col
                            v-if="isProjectPergola && techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-home-edit-outline
                                            </v-icon>
                                            Outdoor
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in pergolasPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.pergolasNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="isProjectPergola && techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.pergolasType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolasType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.pergolasType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolasType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.pergolasNotes != null && serviceDraftingRequest.pergolasNotes != undefined && serviceDraftingRequest.pergolasNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.pergolas, serviceDraftingRequest.pergolasNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <!-- WATER FEATURES -->
                        <v-col
                            v-if="techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-pool
                                            </v-icon>
                                            Water Features
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in waterFeaturesPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.waterFeaturesNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle
                                v-model="serviceDraftingRequest.waterFeaturesType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.waterFeaturesType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.waterFeaturesType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.waterFeaturesType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.waterFeaturesNotes != null && serviceDraftingRequest.waterFeaturesNotes != undefined && serviceDraftingRequest.waterFeaturesNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.waterFeatures, serviceDraftingRequest.waterFeaturesNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQs -->
                        <v-col
                            v-if="isProjectBBQ && techSpecIsRequired"
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-grill
                                            </v-icon>
                                            BBQ´s
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col
                                            v-for="(itemPhoto, index) in bbqPhotos"
                                            :key="index"
                                            cols="12"
                                            lg="2"
                                            md="6"
                                            sm="12"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <v-card
                                                        class="cardDownload"
                                                        v-on="on"
                                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileName)"
                                                    >
                                                        <v-card-title class="cardTitlePhotosDownload">
                                                            <label>{{ itemPhoto.fileName }}</label>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-img
                                                                :src="itemPhoto.src"
                                                                :lazy-src="itemPhoto.src"
                                                                aspect-ratio="1"
                                                                max-height="200"
                                                                max-width="250"
                                                                class="cardImagePhotosDownload"
                                                            >
                                                                <template v-slot:placeholder>
                                                                <v-row
                                                                    class="fill-height ma-0"
                                                                    align="center"
                                                                    justify="center"
                                                                >
                                                                    <v-progress-circular
                                                                        indeterminate
                                                                        color="grey lighten-5"
                                                                    ></v-progress-circular>
                                                                </v-row>
                                                                </template>
                                                            </v-img>
                                                            <span>{{ itemPhoto.createdOn }} by {{ itemPhoto.userName }}</span>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                                <span>Click to Download</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <label>Notes</label>
                                            <v-textarea
                                                v-model="serviceTechSpecRequest.bbqNotes"
                                                rows="4"
                                                row-height="30"
                                                auto-grow
                                                outlined
                                                disabled
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            v-if="isProjectBBQ && techSpecIsRequired"
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbqType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbqType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbqNotes != null && serviceDraftingRequest.bbqNotes != undefined && serviceDraftingRequest.bbqNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbq, serviceDraftingRequest.bbqNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Property Line and Elements -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-chart-line-variant
                                            </v-icon>
                                            Property line and Elements
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.propertyLineAndElementsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLineAndElementsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLineAndElementsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLineAndElementsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.propertyLineAndElementsNotes != null && serviceDraftingRequest.propertyLineAndElementsNotes != undefined && serviceDraftingRequest.propertyLineAndElementsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.propertyLineAndElements, serviceDraftingRequest.propertyLineAndElementsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Overall Dimension of Pool & Deck -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Overall Dimension of Pool & Deck
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.overallDimensionPoolDeckType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimensionPoolDeckType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimensionPoolDeckType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimensionPoolDeckType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.overallDimensionPoolDeckNotes != null && serviceDraftingRequest.overallDimensionPoolDeckNotes != undefined && serviceDraftingRequest.overallDimensionPoolDeckNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.overallDimensionPoolDeck, serviceDraftingRequest.overallDimensionPoolDeckNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Setback Dimension -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Setback Dimension
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.setbackDimensionType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.setbackDimensionType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.setbackDimensionType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.setbackDimensionType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.setbackDimensionNotes != null && serviceDraftingRequest.setbackDimensionNotes != undefined && serviceDraftingRequest.setbackDimensionNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.setbackDimension, serviceDraftingRequest.setbackDimensionNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Shallow and Deep End -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Shallow and Deep End
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.shallowDeepEndType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.shallowDeepEndType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.shallowDeepEndType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.shallowDeepEndType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.shallowDeepEndNotes != null && serviceDraftingRequest.shallowDeepEndNotes != undefined && serviceDraftingRequest.shallowDeepEndNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.shallowDeepEnd, serviceDraftingRequest.shallowDeepEndNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- All Features -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            All Features
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.allFeaturesType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.allFeaturesNotes != null && serviceDraftingRequest.allFeaturesNotes != undefined && serviceDraftingRequest.allFeaturesNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.allFeatures, serviceDraftingRequest.allFeaturesNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Theraphy Jet -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Theraphy Jet
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.theraphyJetType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.theraphyJetType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.theraphyJetType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.theraphyJetType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.theraphyJetNotes != null && serviceDraftingRequest.theraphyJetNotes != undefined && serviceDraftingRequest.theraphyJetNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.theraphyJet, serviceDraftingRequest.theraphyJetNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- House Shown with Single Line -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            House Shown with Single Line
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.houseShownSingleLineType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownSingleLineType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownSingleLineType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownSingleLineType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.houseShownSingleLineNotes != null && serviceDraftingRequest.houseShownSingleLineNotes != undefined && serviceDraftingRequest.houseShownSingleLineNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.houseShownSingleLine, serviceDraftingRequest.houseShownSingleLineNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Contract -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Contract
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.contractType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.contractType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.contractType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.contractType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.contractNotes != null && serviceDraftingRequest.contractNotes != undefined && serviceDraftingRequest.contractNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.contract, serviceDraftingRequest.contractNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Audit Sheet -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Audit Sheet
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.auditSheetType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.auditSheetType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.auditSheetType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.auditSheetType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.auditSheetNotes != null && serviceDraftingRequest.auditSheetNotes != undefined && serviceDraftingRequest.auditSheetNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.auditSheet, serviceDraftingRequest.auditSheetNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Survey or Site Plan -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Survey or Site Plan
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.surveySitePlanType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.surveySitePlanType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.surveySitePlanType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.surveySitePlanType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.surveySitePlanNotes != null && serviceDraftingRequest.surveySitePlanNotes != undefined && serviceDraftingRequest.surveySitePlanNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.surveySitePlan, serviceDraftingRequest.surveySitePlanNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - 2D Drawings(s) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - 2D Drawings(s)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.twoDrawingsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.twoDrawingsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.twoDrawingsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.twoDrawingsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.twoDrawingsNotes != null && serviceDraftingRequest.twoDrawingsNotes != undefined && serviceDraftingRequest.twoDrawingsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.twoDrawings, serviceDraftingRequest.twoDrawingsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - 3D Renderings -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - 3D Renderings
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.threeRenderingsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.threeRenderingsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.threeRenderingsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.threeRenderingsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.threeRenderingsNotes != null && serviceDraftingRequest.threeRenderingsNotes != undefined && serviceDraftingRequest.threeRenderingsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.threeRenderings, serviceDraftingRequest.threeRenderingsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Existing Pictures -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Existing Pictures
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.existingPicturesType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.existingPicturesType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.existingPicturesType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.existingPicturesType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.existingPicturesNotes != null && serviceDraftingRequest.existingPicturesNotes != undefined && serviceDraftingRequest.existingPicturesNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.existingPictures, serviceDraftingRequest.existingPicturesNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - DXF in DXF Group -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - DXF in DXF Group
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.dxfInDxfGroupType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.dxfInDxfGroupType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.dxfInDxfGroupType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.dxfInDxfGroupType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.dxfInDxfGroupNotes != null && serviceDraftingRequest.dxfInDxfGroupNotes != undefined && serviceDraftingRequest.dxfInDxfGroupNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.dxfInDxfGroup, serviceDraftingRequest.dxfInDxfGroupNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Job Release Form -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Job Release Form
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.jobReleaseFormType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.jobReleaseFormType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.jobReleaseFormType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.jobReleaseFormType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.jobReleaseFormNotes != null && serviceDraftingRequest.jobReleaseFormNotes != undefined && serviceDraftingRequest.jobReleaseFormNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.jobReleaseForm, serviceDraftingRequest.jobReleaseFormNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Electrical Load Calc Form w/ Pictures (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Electrical Load Calc Form w/ Pictures (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.electricalLoadCalcType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.electricalLoadCalcType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.electricalLoadCalcType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.electricalLoadCalcType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.electricalLoadCalcNotes != null && serviceDraftingRequest.electricalLoadCalcNotes != undefined && serviceDraftingRequest.electricalLoadCalcNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.electricalLoadCalc, serviceDraftingRequest.electricalLoadCalcNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Lot Coverage Form (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Lot Coverage Form (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.lotCoverageFormType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.lotCoverageFormType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.lotCoverageFormType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.lotCoverageFormType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.lotCoverageFormNotes != null && serviceDraftingRequest.lotCoverageFormNotes != undefined && serviceDraftingRequest.lotCoverageFormNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.lotCoverageForm, serviceDraftingRequest.lotCoverageFormNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - CAD Release Form (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - CAD Release Form (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.cadReleaseFormType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.cadReleaseFormType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.cadReleaseFormType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.cadReleaseFormType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.cadReleaseFormNotes != null && serviceDraftingRequest.cadReleaseFormNotes != undefined && serviceDraftingRequest.cadReleaseFormNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.cadReleaseForm, serviceDraftingRequest.cadReleaseFormNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Soil Report (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Soil Report (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.soilReportType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.soilReportType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.soilReportType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.soilReportType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.soilReportNotes != null && serviceDraftingRequest.soilReportNotes != undefined && serviceDraftingRequest.soilReportNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.soilReport, serviceDraftingRequest.soilReportNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Documents - Driver`s License -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Documents - Driver`s License
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.driverLicenseType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.driverLicenseType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.driverLicenseType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.driverLicenseType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.driverLicenseNotes != null && serviceDraftingRequest.driverLicenseNotes != undefined && serviceDraftingRequest.driverLicenseNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.driverLicense, serviceDraftingRequest.driverLicenseNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Audit Sheet - Does Perimeter Charge include Spa or Sun Shelf -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Audit Sheet - Does Perimeter Charge include Spa or Sun Shelf
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.perimeterChargeIncludeType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.perimeterChargeIncludeType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.perimeterChargeIncludeType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.perimeterChargeIncludeType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.perimeterChargeIncludeNotes != null && serviceDraftingRequest.perimeterChargeIncludeNotes != undefined && serviceDraftingRequest.perimeterChargeIncludeNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.perimeterChargeInclude, serviceDraftingRequest.perimeterChargeIncludeNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Audit Sheet - Is Excavation Charge Included for over 450 SF and/or over 5' Deep -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Audit Sheet - Is Excavation Charge Included for over 450 SF and/or over 5' Deep
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.excavationChargeIncludeType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.excavationChargeIncludeType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.excavationChargeIncludeType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.excavationChargeIncludeType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.excavationChargeIncludeNotes != null && serviceDraftingRequest.excavationChargeIncludeNotes != undefined && serviceDraftingRequest.excavationChargeIncludeNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.excavationChargeInclude, serviceDraftingRequest.excavationChargeIncludeNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Survey - Legible -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Survey - Legible
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.legibleType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.legibleType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.legibleType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.legibleType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.legibleNotes != null && serviceDraftingRequest.legibleNotes != undefined && serviceDraftingRequest.legibleNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.legible, serviceDraftingRequest.legibleNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Survey - Elevation Shown (If Required) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Survey - Elevation Shown (If Required)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.elevationShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.elevationShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.elevationShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.elevationShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.elevationShownNotes != null && serviceDraftingRequest.elevationShownNotes != undefined && serviceDraftingRequest.elevationShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.elevationShown, serviceDraftingRequest.elevationShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Survey - Trees Shown (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Survey - Trees Shown (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.treesShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.treesShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.treesShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.treesShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.treesShownNotes != null && serviceDraftingRequest.treesShownNotes != undefined && serviceDraftingRequest.treesShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.treesShown, serviceDraftingRequest.treesShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Property Lines & Easements Shown -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Property Lines & Easements Shown
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.propertyLinesType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLinesType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLinesType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.propertyLinesType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.propertyLinesNotes != null && serviceDraftingRequest.propertyLinesNotes != undefined && serviceDraftingRequest.propertyLinesNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.propertyLines, serviceDraftingRequest.propertyLinesNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Fence and Gates Shown & Called Out -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Fence and Gates Shown & Called Out
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.fenceAndGatesShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.fenceAndGatesShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.fenceAndGatesShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.fenceAndGatesShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.fenceAndGatesShownNotes != null && serviceDraftingRequest.fenceAndGatesShownNotes != undefined && serviceDraftingRequest.fenceAndGatesShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.fenceAndGatesShown, serviceDraftingRequest.fenceAndGatesShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Overall Dims of Pool, Spa, Deck, Walls, Sunken Area, etc -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Overall Dims of Pool, Spa, Deck, Walls, Sunken Area, etc
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.overallDimsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.overallDimsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.overallDimsNotes != null && serviceDraftingRequest.overallDimsNotes != undefined && serviceDraftingRequest.overallDimsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.overallDims, serviceDraftingRequest.overallDimsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Dims from Pool & Deck to the Property Lines -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Dims from Pool & Deck to the Property Lines
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.dimsFromPoolType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.dimsFromPoolType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.dimsFromPoolType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.dimsFromPoolType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.dimsFromPoolNotes != null && serviceDraftingRequest.dimsFromPoolNotes != undefined && serviceDraftingRequest.dimsFromPoolNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.dimsFromPool, serviceDraftingRequest.dimsFromPoolNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Equipment Pad Location -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Equipment Pad Location
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.equipmentPadLocationType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.equipmentPadLocationType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.equipmentPadLocationType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.equipmentPadLocationType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.equipmentPadLocationNotes != null && serviceDraftingRequest.equipmentPadLocationNotes != undefined && serviceDraftingRequest.equipmentPadLocationNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.equipmentPadLocation, serviceDraftingRequest.equipmentPadLocationNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Shallow and Deep End Shown -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Shallow and Deep End Shown (If it’s 5’ or Deeper, A Swimout is Needed)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.shallowAndDeepEndShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.shallowAndDeepEndShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.shallowAndDeepEndShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.shallowAndDeepEndShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.shallowAndDeepEndShownNotes != null && serviceDraftingRequest.shallowAndDeepEndShownNotes != undefined && serviceDraftingRequest.shallowAndDeepEndShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.shallowAndDeepEndShown, serviceDraftingRequest.shallowAndDeepEndShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - All Lights are Shown -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - All Lights are Shown
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.allLightsAreShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.allLightsAreShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.allLightsAreShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.allLightsAreShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.allLightsAreShownNotes != null && serviceDraftingRequest.allLightsAreShownNotes != undefined && serviceDraftingRequest.allLightsAreShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.allLightsAreShown, serviceDraftingRequest.allLightsAreShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - All Features are Shown (Bubblers, Deck Jets, Raised Walls, etc.) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - All Features are Shown (Bubblers, Deck Jets, Raised Walls, etc.)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.allFeaturesAreShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesAreShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesAreShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.allFeaturesAreShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.allFeaturesAreShownNotes != null && serviceDraftingRequest.allFeaturesAreShownNotes != undefined && serviceDraftingRequest.allFeaturesAreShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.allFeaturesAreShown, serviceDraftingRequest.allFeaturesAreShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Jet Locations (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Jet Locations (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.jetLocationsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.jetLocationsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.jetLocationsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.jetLocationsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.jetLocationsNotes != null && serviceDraftingRequest.jetLocationsNotes != undefined && serviceDraftingRequest.jetLocationsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.jetLocations, serviceDraftingRequest.jetLocationsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Landscaping and Furniture are not Shown -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Landscaping and Furniture are not Shown
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.landscapingAndFurnitureAreNotShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.landscapingAndFurnitureAreNotShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.landscapingAndFurnitureAreNotShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.landscapingAndFurnitureAreNotShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes != null && serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes != undefined && serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.landscapingAndFurnitureAreNotShown, serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - House Shown with Single Line (Not Double Line) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - House Shown with Single Line (Not Double Line) 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.houseShownWithSingleLineType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownWithSingleLineType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownWithSingleLineType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.houseShownWithSingleLineType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.houseShownWithSingleLineNotes != null && serviceDraftingRequest.houseShownWithSingleLineNotes != undefined && serviceDraftingRequest.houseShownWithSingleLineNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.houseShownWithSingleLine, serviceDraftingRequest.houseShownWithSingleLineNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- 2D Drawing - Is There Water Level Control -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            2D Drawing - Is There Water Level Control 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.isThereWaterLevelControlType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.isThereWaterLevelControlType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.isThereWaterLevelControlType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.isThereWaterLevelControlType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.isThereWaterLevelControlNotes != null && serviceDraftingRequest.isThereWaterLevelControlNotes != undefined && serviceDraftingRequest.isThereWaterLevelControlNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.isThereWaterLevelControl, serviceDraftingRequest.isThereWaterLevelControlNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQ - 3D Rendering -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            BBQ - 3D Rendering 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbq3DRenderingsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbq3DRenderingsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbq3DRenderingsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbq3DRenderingsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbq3DRenderingsNotes != null && serviceDraftingRequest.bbq3DRenderingsNotes != undefined && serviceDraftingRequest.bbq3DRenderingsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbq3DRenderings, serviceDraftingRequest.bbq3DRenderingsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQ - Appliances Shown and Labeled w/ Proper Spacing -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            BBQ - Appliances Shown and Labeled w/ Proper Spacing 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbqAppliancesShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqAppliancesShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbqAppliancesShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqAppliancesShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbqAppliancesShownNotes != null && serviceDraftingRequest.bbqAppliancesShownNotes != undefined && serviceDraftingRequest.bbqAppliancesShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbqAppliancesShown, serviceDraftingRequest.bbqAppliancesShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQ - Natural, Propane Gas or Portable Propane? -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            BBQ - Natural, Propane Gas or Portable Propane? 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbqNaturalPropaneGasType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqNaturalPropaneGasType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbqNaturalPropaneGasType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqNaturalPropaneGasType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbqNaturalPropaneGasNotes != null && serviceDraftingRequest.bbqNaturalPropaneGasNotes != undefined && serviceDraftingRequest.bbqNaturalPropaneGasNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbqNaturalPropaneGas, serviceDraftingRequest.bbqNaturalPropaneGasNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQ - Is there a Sink? -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            BBQ - Is there a Sink? 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbqIsThereSinkType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqIsThereSinkType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbqIsThereSinkType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqIsThereSinkType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbqIsThereSinkNotes != null && serviceDraftingRequest.bbqIsThereSinkNotes != undefined && serviceDraftingRequest.bbqIsThereSinkNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbqIsThereSink, serviceDraftingRequest.bbqIsThereSinkNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- BBQ - Electrical is at least 6’ away from Water -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            BBQ - Electrical is at least 6’ away from Water 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes != null && serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes != undefined && serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.bbqElectricalIsAtLeast6AwayFromWater, serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Pergola - Overall Dims -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Outdoor - Overall Dims 
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.pergolaOverallDimsType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaOverallDimsType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaOverallDimsType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaOverallDimsType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.pergolaOverallDimsNotes != null && serviceDraftingRequest.pergolaOverallDimsNotes != undefined && serviceDraftingRequest.pergolaOverallDimsNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.pergolaOverallDims, serviceDraftingRequest.pergolaOverallDimsNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Pergola - Lights & Fans are Shown (If Applicable) -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Outdoor - Lights & Fans are Shown (If Applicable)
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.pergolaLightsAndFansAreShownType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaLightsAndFansAreShownType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaLightsAndFansAreShownType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaLightsAndFansAreShownType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.pergolaLightsAndFansAreShownNotes != null && serviceDraftingRequest.pergolaLightsAndFansAreShownNotes != undefined && serviceDraftingRequest.pergolaLightsAndFansAreShownNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.pergolaLightsAndFansAreShown, serviceDraftingRequest.pergolaLightsAndFansAreShownNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Pergola - Fan(s) are 5’ away from Water -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Outdoor - Fan(s) are 5’ away from Water
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.pergolaFanAre5AwayFromWaterType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaFanAre5AwayFromWaterType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaFanAre5AwayFromWaterType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaFanAre5AwayFromWaterType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes != null && serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes != undefined && serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.pergolaFanAre5AwayFromWater, serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>
                        
                        <!-- Pergola - Electrical is 6’ away from Water -->
                        <v-col
                            style="padding-top: 10px !important;"
                            cols="10"
                            lg="9"
                            md="10"
                            sm="10"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                        >
                                            <v-icon color="primary" left>
                                                mdi-triforce
                                            </v-icon>
                                            Outdoor - Electrical is 6’ away from Water
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                            </v-expansion-panel>
                        </v-col>
                        <v-col
                            style="display: flex; align-content: center; align-items: center;"
                            cols="2"
                            lg="3"
                            md="2"
                            sm="2"
                        >
                            <v-btn-toggle 
                                v-model="serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType"
                            >
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType = 0" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleDenied"
                                >
                                    <v-icon left class="btnToogleDenied">mdi-thumb-down-outline</v-icon>Denied
                                </v-btn>

                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType = 1" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleApproved"
                                >
                                    <v-icon left class="btnToogleApproved">mdi-thumb-up-outline</v-icon>Approved
                                </v-btn>
                                <v-btn 
                                    @click="serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType = 2" 
                                    :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                    class="btnToogleNA"
                                >
                                    <v-icon left>mdi-minus-circle-outline</v-icon>N/A
                                </v-btn>

                            </v-btn-toggle>

                            <v-tooltip 
                                left
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        class="btnActions"
                                        :style="serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes != null && serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes != undefined && serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes != '' ? 'width: 35px; height:35px !important;' : 'color: gray !important; width: 35px; height:35px !important;'"
                                        icon 
                                        small 
                                        outlined
                                        v-on="on"
                                    >
                                        <v-icon small @click="showItem(titles.pergolaElectricalIs6AwayFromWater, serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes)">mdi-message-bulleted</v-icon>
                                    </v-btn>
                                </template>
                                <span>View Notes</span>
                            </v-tooltip>
                        </v-col>

                        <v-dialog
                            v-model="showDialogItemNote"
                            transition="dialog-top-transition"
                            persistent
                            width="800"
                            :fullscreen="$vuetify.breakpoint.mobile"
                        >
                        
                            <v-card>
                                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                                    {{ itemTitle }}
                                </v-card-title>

                                <v-card-text style="margin-top: 20px;">
                                    <v-row>
                                        <v-col 
                                            cols="12"
                                            lg="12"
                                            md="12"
                                            sm="12"
                                        >
                                            <label>Explain the denied reason</label>
                                            
                                            <v-textarea
                                                v-model="itemReasonDescription"
                                                :disabled="userLoggedGetters.profile.readOnlyDrafting == 1"
                                                single-line
                                                rows="3"
                                                row-height="30"
                                                outlined
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <div style="width: 100%; text-align: center;">
                                        <v-btn 
                                            v-if="userLoggedGetters.profile.readOnlyDrafting == 1"
                                            class="mx-2"
                                            style="background-color: var(--color__silver) !important; color: #ffffff !important"
                                            @click="showDialogItemNote = false"
                                        >
                                            Dismiss
                                        </v-btn>
                                        <v-btn
                                            v-if="userLoggedGetters.profile.readOnlyDrafting != 1"
                                            class="mx-2 buttonCancelDialog"
                                            style=""
                                            outlined
                                            @click="showDialogItemNote = false"
                                        >
                                            Cancel
                                        </v-btn>

                                        <v-btn
                                            v-if="userLoggedGetters.profile.readOnlyDrafting != 1"
                                            class="mx-2"
                                            outlined
                                            @click="saveItem()"
                                        >
                                            Save
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-expansion-panels>

                </v-stepper-content>

                <!-- STEP 2: DRAFTER TEAM -->
                <v-stepper-content step="2">
                    
                    <v-row>
                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Drafting Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="drafterTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemDrafter, index) in listDrafters"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemDrafter.userName }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Permit Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="permitTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemPermit, index) in listPermit"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemPermit.userName }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Electric Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="electricTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemTechTeam, index) in listElectricTech"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemTechTeam.name }}</v-list-item-title>
                                                            
                                                            <v-text-field
                                                                v-if="itemTechTeam.id == -1 && active"
                                                                v-model="electricTeamOtherName" 
                                                                single-line
                                                                outlined
                                                                dense
                                                                @keyup.prevent=""
                                                                @click.stop=""
                                                            >
                                                            </v-text-field>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Plumbing Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="plumbingTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemTechTeam, index) in listPlumbingTech"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemTechTeam.name }}</v-list-item-title>
                                                            
                                                            <v-text-field
                                                                v-if="itemTechTeam.id == -1 && active"
                                                                v-model="plumbingTeamOtherName" 
                                                                single-line
                                                                outlined
                                                                dense
                                                                @keyup.prevent=""
                                                                @click.stop=""
                                                            >
                                                            </v-text-field>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Gas Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="gasTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemTechTeam, index) in listGasTech"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemTechTeam.name }}</v-list-item-title>
                                                            
                                                            <v-text-field
                                                                v-if="itemTechTeam.id == -1 && active"
                                                                v-model="gasTeamOtherName" 
                                                                single-line
                                                                outlined
                                                                dense
                                                                @keyup.prevent=""
                                                                @click.stop=""
                                                            >
                                                            </v-text-field>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>

                        <v-col 
                            cols="12"
                            xlg="2"
                            lg="2"
                            md="4"
                            sm="12"
                        >
                            <v-card-text>

                                <v-card
                                    class="mx-auto"
                                    justify-center
                                >
                                    <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                        Choose Engineering Team
                                    </v-card-title>
                                    <v-card-text style="margin-top: 20px;">
                                        <v-list
                                            rounded
                                        >
                                            
                                            <v-list-item-group
                                                v-model="engineerTeam"
                                                multiple
                                            >
                                                <v-list-item
                                                    v-for="(itemTechTeam, index) in listEngineerTech"
                                                    :key="index"
                                                >
                                                    <template v-slot:default="{ active, }">
                                                        <v-list-item-action>
                                                            <v-checkbox
                                                                :input-value="active"
                                                                color="primary"
                                                            ></v-checkbox>
                                                        </v-list-item-action>

                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ itemTechTeam.name }}</v-list-item-title>
                                                            
                                                            <v-text-field
                                                                v-if="itemTechTeam.id == -1 && active"
                                                                v-model="engineerTeamOtherName" 
                                                                single-line
                                                                outlined
                                                                dense
                                                                @keyup.prevent=""
                                                                @click.stop=""
                                                            >
                                                            </v-text-field>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>      
                                            </v-list-item-group>
                                        </v-list>
                                    </v-card-text>

                                </v-card>
                                
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-stepper-content>

            </v-stepper-items>
        </v-stepper>
            
        <!-- Buttons: NEXT | BACK -->
        
        <div 
            v-if="userLoggedGetters.profile.readOnlyDrafting == 1"
            class="text-center"
        >
            
            <v-row>
                <v-col 
                    style="padding: 15px"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="mx-2"
                                v-on="on"
                                style="background-color: var(--color__silver) !important; color: #ffffff !important"
                                @click="back()"
                            >
                                Back
                            </v-btn>
                        </template>
                        <span>Back</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>

        <div 
            v-else
            class="text-center"
        >
            <v-row
                style="padding-top: 50px"
            >
                <v-col 
                    style="text-align: right"
                    cols="6"
                    lg="5"
                    md="4"
                    sm="6"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="mx-2"
                                v-on="on"
                                @click="cancel"
                                style="background-color: var(--color__red) !important; color: #ffffff !important;"
                            >
                                Cancel
                            </v-btn>
                        </template>
                        <span>Cancel</span>
                    </v-tooltip>
                </v-col>
                <v-col 
                    style="text-align: center"
                    cols="12"
                    lg="2"
                    md="4"
                    sm="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn 
                                class="mx-2"
                                v-on="on"
                                :disabled="steps == 1"
                                style="background-color: var(--color__silver) !important; color: #ffffff !important"
                                @click="steps = 1"
                            >
                                Back
                            </v-btn>
                        </template>
                        <span>Back Previous Step</span>
                    </v-tooltip>
                </v-col>
                
                <v-col 
                    v-if="steps == 1"
                    style="text-align: left"
                    cols="12"
                    lg="5"
                    md="4"
                    sm="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mx-2"
                                v-on="on"
                                @click="saveDrafting()"
                            >
                                Next
                            </v-btn>
                        </template>
                        <span>Go To Next Step</span>
                    </v-tooltip>
                </v-col>
                <v-col 
                    v-if="steps == 2"
                    style="text-align: left"
                    cols="12"
                    lg="5"
                    md="4"
                    sm="12"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mx-2"
                                v-on="on"
                                @click="validateAndFinishDrafting()"
                            >
                                Finish
                            </v-btn>
                        </template>
                        <span>Finish</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </div>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import { formaterDecimalBR } from '@/utilities/Utils';
    import ActionDialog from "@/components/Layout/ActionDialog";
    import JobInformation from "@/components/Services/JobInformation";
    import { 
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT, 
        CATEGORY_TEAM, 
        CONTRACTOR_CATEGORY, 
        URL_ATTACHMENT,
        PROJECT_STATUS
    } from "@/utilities/Enums";

    export default ({

        components: {
            ActionDialog,
            JobInformation
        },

        mixins: [Helpers],

        data: () => ({
            URL_ATTACHMENT,

            steps: 1,

			serviceProjectResponse: {
                id: 0,
                userNameRegister: "",
                customerSelected: {
                    name: ""
                },
                addressSelected: {
                    address: ""
                },
            },

            projectSelected: null,
            refreshJob: false,

            serviceTechSpecRequest: {
                id: 0,
                idService: 0,
                surveyTypeSelected: null,
                dimensionedEquipmentLocation: 0,
                dimensionedEquipmentLocationNotes: "",
                fenceType: "",
                fenceLocation: 0,
                fenceLocationNotes: "",
                depthDeepestPointLocation: 0,
                depthDeepestPointLocationNotes: "",
                lightLocations: 0,
                lightLocationsNotes: "",
                soilTest: 0,
                pergolas: 0,
                pergolasNotes: "",
                waterFeatures: 0,
                waterFeaturesNotes: "",
                bbq: 0,
                bbqNotes: "",                
            },

            titles: {
                serviceInformation: "Job information",
                scopeOfWork: "Scope of Work",
                details: "Attachments",
                dimensionedEquipmentLocation: "Equipment Location",
                fenceEnclosureInformation: "Pool Barrier",
                fenceLocation: "Fence Location",
                depthDeepestPointLocation: "Depth Deepest Point Location",
                lightLocations: "Light Locations",
                soilTest: "Soil Test",
                pergolas: "Outdoor",
                waterFeatures: "Water Features",
                bbq: "BBQ´s",
                propertyLineAndElements: "Property line and Elements",
                overallDimensionPoolDeck: 'Overall Dimension of Pool & Deck',
                setbackDimension: 'Setback Dimension',
                shallowDeepEnd: 'Shallow and Deep End',
                allFeatures: 'All features',
                theraphyJet: 'Theraphy Jet',
                houseShownSingleLine: 'House Shown with Single Line',
                contract: 'Contract',
                auditSheet: 'Audit Sheet',
                surveySitePlan: 'Survey Site Plan',
                twoDrawings: '2D Drawings',
                threeRenderings: '3D Renderings',
                existingPictures: 'Existing Pictures',
                dxfInDxfGroup: 'DXF in DXF Group',
                jobReleaseForm: 'Job Release Form',
                electricalLoadCalc: 'Electrical Load Calc Form w/ Pictures',
                lotCoverageForm: 'Lot Coverage Form',
                cadReleaseForm: 'CAD Release Form',
                soilReport: 'Soil Report',
                driverLicense: 'Driver`s License',
                perimeterChargeInclude: 'Perimeter Charge Include',
                excavationChargeInclude: 'Excavation Charge Include',
                legible: 'Legible',
                elevationShown: 'Elevation Shown',
                treesShown: 'Trees Shown',
                fenceAndGatesShown: 'Fence and Gates Shown',
                overallDims: 'Overall Dimensions',
                dimsFromPool: 'Dimensions from Pool',
                equipmentPadLocation: 'Equipment Pad Location',
                shallowAndDeepEndShown: 'Shallow and Deep End Shown',
                allLightsAreShown: 'All Lights are Shown',
                allFeaturesAreShown: 'All Features are Shown',
                jetLocations: 'Jet Locations',
                landscapingAndFurnitureAreNotShown: 'Landscaping and Furniture are not Shown',
                houseShownWithSingleLine: 'House Shown with Single Line',
                isThereWaterLevelControl: 'Is there Water Level Control',
                bbq3DRenderings: 'BBQ 3D Renderings',
                bbqAppliancesShown: 'BBQ Appliances Shown',
                bbqNaturalPropaneGas: 'BBQ Natural/Propane Gas',
                bbqIsThereSink: 'BBQ Is there Sink',
                bbqElectricalIsAtLeast6AwayFromWater: 'BBQ Electrical is at least 6\' away from water',
                pergolaOverallDims: 'Outdoor Overall Dimensions',
                pergolaLightsAndFansAreShown: 'Outdoor Lights and Fans are Shown',
                pergolaFanAre5AwayFromWater: 'Outdoor Fan are 5\' away from water',
                pergolaElectricalIs6AwayFromWater: 'Outdoor Electrical is 6\' away from water',
            },

            serviceDraftingRequest: {
                id: 0,
                idService: 0,
                serviceInformationType: 2,
                serviceInformationNotes: "",
                scopeOfWorkType: 2,
                scopeOfWorkNotes: "",
                detailsType: 2,
                detailsNotes: "",
                dimensionedEquipmentLocationType: 2,
                dimensionedEquipmentLocationNotes: "",
                fenceEnclosureInformationType: 2,
                fenceEnclosureInformationNotes: "",
                fenceLocationType: 2,
                fenceLocationNotes: "",
                depthDeepestPointLocationType: 2,
                depthDeepestPointLocationNotes: "",
                lightLocationsType: 2,
                lightLocationsNotes: "",
                soilTestType: 2,
                soilTestNotes: "",
                pergolasType: 2,
                pergolasNotes: "",
                waterFeaturesType: 2,
                waterFeaturesNotes: "",
                bbqType: 2,
                bbqNotes: "",
                propertyLineAndElementsType: 2,
                propertyLineAndElementsNotes: "",
                overallDimensionPoolDeckType: 2,
                overallDimensionPoolDeckNotes: "",
                setbackDimensionType: 2,
                setbackDimensionNotes: "",
                shallowDeepEndType: 2,
                shallowDeepEndNotes: "",
                allFeaturesType: 2,
                allFeaturesNotes: "",
                theraphyJetType: 2,
                theraphyJetNotes: "",
                houseShownSingleLineType: 2,
                houseShownSingleLineNotes: "",
                contractType: 2,
                contractNotes: "",
                auditSheetType: 2,
                auditSheetNotes: "",
                surveySitePlanType: 2,
                surveySitePlanNotes: "",
                twoDrawingsType: 2,
                twoDrawingsNotes: "",
                threeRenderingsType: 2,
                threeRenderingsNotes: "",
                existingPicturesType: 2,
                existingPicturesNotes: "",
                dxfInDxfGroupType: 2,
                dxfInDxfGroupNotes: "",
                jobReleaseFormType: 2,
                jobReleaseFormNotes: "",
                electricalLoadCalcType: 2,
                electricalLoadCalcNotes: "",
                lotCoverageFormType: 2,
                lotCoverageFormNotes: "",
                cadReleaseFormType: 2,
                cadReleaseFormNotes: "",
                soilReportType: 2,
                soilReportNotes: "",
                driverLicenseType: 2,
                driverLicenseNotes: "",
                perimeterChargeIncludeType: 2,
                perimeterChargeIncludeNotes: "",
                excavationChargeIncludeType: 2,
                excavationChargeIncludeNotes: "",
                legibleType: 2,
                legibleNotes: "",
                elevationShownType: 2,
                elevationShownNotes: "",
                treesShownType: 2,
                treesShownNotes: "",
                propertyLinesType: 2,
                propertyLinesNotes: "",
                fenceAndGatesShownType: 2,
                fenceAndGatesShownNotes: "",
                overallDimsType: 2,
                overallDimsNotes: "",
                dimsFromPoolType: 2,
                dimsFromPoolNotes: "",
                equipmentPadLocationType: 2,
                equipmentPadLocationNotes: "",
                shallowAndDeepEndShownType: 2,
                shallowAndDeepEndShownNotes: "",
                allLightsAreShownType: 2,
                allLightsAreShownNotes: "",
                allFeaturesAreShownType: 2,
                allFeaturesAreShownNotes: "",
                jetLocationsType: 2,
                jetLocationsNotes: "",
                landscapingAndFurnitureAreNotShownType: 2,
                landscapingAndFurnitureAreNotShownNotes: "",
                houseShownWithSingleLineType: 2,
                houseShownWithSingleLineNotes: "",
                isThereWaterLevelControlType: 2,
                isThereWaterLevelControlNotes: "",
                bbq3DRenderingsType: 2,
                bbq3DRenderingsNotes: "",
                bbqAppliancesShownType: 2,
                bbqAppliancesShownNotes: "",
                bbqNaturalPropaneGasType: 2,
                bbqNaturalPropaneGasNotes: "",
                bbqIsThereSinkType: 2,
                bbqIsThereSinkNotes: "",
                bbqElectricalIsAtLeast6AwayFromWaterType: 2,
                bbqElectricalIsAtLeast6AwayFromWaterNotes: "",
                pergolaOverallDimsType: 2,
                pergolaOverallDimsNotes: "",
                pergolaLightsAndFansAreShownType: 2,
                pergolaLightsAndFansAreShownNotes: "",
                pergolaFanAre5AwayFromWaterType: 2,
                pergolaFanAre5AwayFromWaterNotes: "",
                pergolaElectricalIs6AwayFromWaterType: 2,
                pergolaElectricalIs6AwayFromWaterNotes: "",
            },

            statusService: 0,

            itemTitle: "",
            itemReasonDescription: "",
            showDialogItemNote: false,

            listProductSelecteds: [],

            idServiceItem: 0,

            grandTotal: "$ 0.00",

            surveyFile: {
                id: 0,
                fileName: "",
                fileType: "",
                createdOn: "",
                userName: "",
            },

            poolStudioDXFFile: {
                id: 0,
                fileName: "",
                fileType: "",
                createdOn: "",
                userName: "",
            },

            poolStudioPDFFile: {
                id: 0,
                fileName: "",
                fileType: "",
                createdOn: "",
                userName: "",
            },

            architecturalSitePlanFile: {
                id: 0,
                fileName: "",
                fileType: "",
                createdOn: "",
                userName: "",
            },

            dimensionedEquipmentLocationPhotos: [],
            fenceLocationPhotos: [],
            depthDeepestPointLocationPhotos: [],
            lightLocationsPhotos: [],

            soilTestFile: {
                id: 0,
                fileName: "",
                fileType: "",
                createdOn: "",
                userName: "",
            },

            pergolasPhotos: [],
            waterFeaturesPhotos: [],
            bbqPhotos: [],

            fenceTypeSelected: [],

            listSurveyType: [
                { id: 1, description: 'Temp' },
                { id: 2, description: 'Final' },
                { id: 3, description: 'More Than 5 Year' }
            ],

            listFenceType: [
                { id: 1, description: 'Pool Cover' },
                { id: 2, description: 'Baby Fence' },
                { id: 3, description: 'Alarm' },
                { id: 4, description: 'Combination' },
                { id: 5, description: 'Screen Enclosure' },
                { id: 6, description: 'AI Cameras' },
                { id: 7, description: 'Perimeter Fence' },
                { id: 8, description: 'Floating Alarm' },
                { id: 9, description: 'Cooping Alarm' },
            ],

            listDrafters: [],
            drafterTeam: [],
            listPermit: [],
            permitTeam: [],
            listElectricTech: [],
            electricTeam: [],
            electricTeamOtherName: '',
            listPlumbingTech: [],
            plumbingTeam: [],
            plumbingTeamOtherName: '',
            listGasTech: [],
            gasTeam: [],
            gasTeamOtherName: '',
            listEngineerTech: [],
            engineerTeam: [],
            engineerTeamOtherName: '',

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },
            
            validations: {
                required: required,
            },

            og: Math.pow(10, 2),

            PROJECT_STATUS,

        }),

        props: {
            id: {
                default: 0
            }
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState', menuGetter: 'menuState' }),

            isProjectBBQ() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.bbq == 1;
            },

            isProjectPergola() {
                return this.projectSelected != null && this.projectSelected != undefined && this.projectSelected.pergola == 1;
            },

            techSpecIsRequired() {
                // return this.serviceRequest.techSpecIsRequired == 1;
                return 1;
            },
        },

        methods: {
            
            async back() {
                history.go(-1);
            },

            async getTechSpec() {

                const responseTechSpec = await this.$store.dispatch("serviceModule/GetTechSpecById", this.id);
                this.serviceTechSpecRequest = responseTechSpec.result;
                this.serviceTechSpecRequest.surveyTypeSelected = {
                    id: this.serviceTechSpecRequest.surveyType,
                    description: this.serviceTechSpecRequest.surveyTypeDescription
                }
                
                const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.PROJECT.value, idKey: this.id });

                //DETAILS
                let itemSessionDetailSurveyType = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.SURVEY.value)[0];               
                if (itemSessionDetailSurveyType != null && itemSessionDetailSurveyType != undefined) {

                    this.surveyFile = {
                        id: itemSessionDetailSurveyType.id,
                        fileName: itemSessionDetailSurveyType.fileName,
                        fileType: itemSessionDetailSurveyType.fileType,
                        createdOn: itemSessionDetailSurveyType.dateRegisterFormatted,
                        userName: itemSessionDetailSurveyType.userNameRegister
                    }
                }

                let itemSessionDetailPoolStudioDXF = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.POOL_STUDIO_DXF.value)[0];
                if (itemSessionDetailPoolStudioDXF != null && itemSessionDetailPoolStudioDXF != undefined) {

                    this.poolStudioDXFFile = {
                        id: itemSessionDetailPoolStudioDXF.id,
                        fileName: itemSessionDetailPoolStudioDXF.fileName,
                        fileType: itemSessionDetailPoolStudioDXF.fileType,
                        createdOn: itemSessionDetailPoolStudioDXF.dateRegisterFormatted,
                        userName: itemSessionDetailPoolStudioDXF.userNameRegister
                    }
                }

                let itemSessionDetailPoolStudioPDF = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.POOL_STUDIO_PDF.value)[0];
                if (itemSessionDetailPoolStudioPDF != null && itemSessionDetailPoolStudioPDF != undefined) {

                    this.poolStudioPDFFile = {
                        id: itemSessionDetailPoolStudioPDF.id,
                        fileName: itemSessionDetailPoolStudioPDF.fileName,
                        fileType: itemSessionDetailPoolStudioPDF.fileType,
                        createdOn: itemSessionDetailPoolStudioPDF.dateRegisterFormatted,
                        userName: itemSessionDetailPoolStudioPDF.userNameRegister
                    }
                }

                let itemSessionDetailArchitecturalSitePlan = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.ARCHITECTURAL_SITE_PLAN.value)[0];
                if (itemSessionDetailArchitecturalSitePlan != null && itemSessionDetailArchitecturalSitePlan != undefined) {

                    this.architecturalSitePlanFile = {
                        id: itemSessionDetailArchitecturalSitePlan.id,
                        fileName: itemSessionDetailArchitecturalSitePlan.fileName,
                        fileType: itemSessionDetailArchitecturalSitePlan.fileType,
                        createdOn: itemSessionDetailArchitecturalSitePlan.dateRegisterFormatted,
                        userName: itemSessionDetailArchitecturalSitePlan.userNameRegister
                    }
                }
                
                //EQUIPMENT LOCATION
                let listItemSessionDimensionedEquipmentLocation = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.DIMENSIONED_EQUIPMENT_LOCATION.value);  
                listItemSessionDimensionedEquipmentLocation.forEach(itemPhoto => {

                    this.dimensionedEquipmentLocationPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })

                // POOL BARRIER
                let listIDFenceType = this.serviceTechSpecRequest.fenceType.split(';');
                await listIDFenceType.forEach(itemFence => {
                    if (itemFence) {

                        this.fenceTypeSelected.push({
                            id: parseInt(itemFence),
                            description: this.listFenceType.filter(fen => fen.id == parseInt(itemFence))[0].description
                        })
                    }
                })
                
                //FENCE LOCATION
                let listItemSessionFenceLocation = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.FENCE_LOCATION.value);
                listItemSessionFenceLocation.forEach(itemPhoto => {

                    this.fenceLocationPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })
                
                //DEPH DEEPEST POINT LOCATION
                let listItemSessionDepthDeepestPointLocation = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.DEPH_DEEPEST_POINT_LOCATION.value);  
                listItemSessionDepthDeepestPointLocation.forEach(itemPhoto => {

                    this.depthDeepestPointLocationPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })
                
                //LIGHT LOCATIONS
                let listItemSessionLightLocations = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.LIGHT_LOCATIONS.value);
                listItemSessionLightLocations.forEach(itemPhoto => {

                    this.lightLocationsPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })

                //SOIL TEST
                let itemSessionSoilTest = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.SOIL_TEST.value)[0];
                if (itemSessionSoilTest != null && itemSessionSoilTest != undefined) {
                    
                    this.soilTestFile = {
                        id: itemSessionSoilTest.id,
                        fileName: itemSessionSoilTest.fileName,
                        fileType: itemSessionSoilTest.fileType,
                        createdOn: itemSessionSoilTest.dateRegisterFormatted,
                        userName: itemSessionSoilTest.userNameRegister
                    }
                }
                
                //PERGOLAS
                let listItemSessionPergolas = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.PERGOLAS.value);
                listItemSessionPergolas.forEach(itemPhoto => {

                    this.pergolasPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })
                
                //WATER FEATURES
                let listItemSessionWaterFeatures = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.WATER_FEATURES.value);  
                listItemSessionWaterFeatures.forEach(itemPhoto => {

                    this.waterFeaturesPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })
                
                //BBQ
                let listItemSessionBBQ = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.BBQ.value);  
                listItemSessionBBQ.forEach(itemPhoto => {

                    this.bbqPhotos.push({
                        id: itemPhoto.id,
                        fileName: itemPhoto.fileNameShort,
                        fileType: itemPhoto.fileType,
                        createdOn: itemPhoto.dateRegisterFormatted,
                        userName: itemPhoto.userNameRegister,
                        src: `data:image/jpg;base64,${itemPhoto.file}`
                    })

                })
            },
            
            async getRegister() {

                if (this.id !== 0) {

                    const responseDrafting = await this.$store.dispatch("serviceModule/GetDraftingById", this.id);

                    const response = await this.$store.dispatch("serviceModule/GetServiceProjectById", this.id);

                    this.serviceProjectResponse = response.result;

                    this.projectSelected = {
                        id: this.serviceProjectResponse.id,
                        idService: this.serviceProjectResponse.idService,
                        classification: this.serviceProjectResponse.classification,
                        name: this.serviceProjectResponse.name,
                        step: this.serviceProjectResponse.step,
                        version: this.serviceProjectResponse.version,
                        versionName: this.serviceProjectResponse.versionName,
                        totalProject: this.serviceProjectResponse.totalProject
                    }

                    if (responseDrafting.result.id != 0) {
                        const _response = responseDrafting.result;
                        const _responseLC = {};
                        Object.keys(_response).forEach(k => { _responseLC[k.toLowerCase()] = _response[k]; });
                        Object.keys(this.serviceDraftingRequest).forEach(key => {
                            const val = _response[key] !== undefined ? _response[key] : _responseLC[key.toLowerCase()];
                            if (val !== undefined) {
                                this.serviceDraftingRequest[key] = val;
                            }
                        });

                        this.refreshJob = !this.refreshJob;

                        const listTeam = await this.$store.dispatch("serviceModule/GetTeam", this.id);

                        this.drafterTeam = [];

                        if (listTeam.length > 0) {
                            let index = 0
                            listTeam.forEach ( () => {
                                this.drafterTeam.push(index);
                                index++;
                            })
                        }
                    }

                    await this.getTechSpec();
                    await this.updateItems();
                }
            },

            async updateProject(projectSelected) {

                this.showLoading();

                this.projectSelected = projectSelected;

                this.hideLoading();
            },

            async getLists() {                
                this.listTreeView = await this.$store.dispatch("productModule/ListProductsToScopeOfWork", { id: this.id, type: 'SERVICE', showOnlyCreatedItems: false, fromHistory: false });
                this.listTemplate = await this.$store.dispatch("templateModule/List");
            },

            async updateItems() {
                
                this.listProductSelecteds = [];
                let grandTotal = 0;
                this.listTreeView.forEach(itemCategory => {
                    itemCategory.children.forEach(itemSubCategoryOrProduct => {
                        
                        if (itemSubCategoryOrProduct.type == 'SubCategory') {

                            itemSubCategoryOrProduct.children.forEach(itemProduct => {

                                if (itemProduct.qty != null && itemProduct.qty != undefined && itemProduct.qty != "0.00" && itemProduct.qty != "" ) {

                                    let qty = parseFloat(itemProduct.qty == '' ? 0 : itemProduct.qty);
                                    
                                    let total = (qty * itemProduct.price).toFixed(2);

                                    this.listProductSelecteds.push({
                                        id: itemProduct.idServiceItem,
                                        idService: this.id,
                                        idCategory: itemCategory.id,
                                        categoryDescription: itemCategory.name,
                                        idSubCategory: itemSubCategoryOrProduct.id,
                                        subCategoryDescription: itemSubCategoryOrProduct.name,
                                        productDescription: itemProduct.name,
                                        idProduct: itemProduct.idTable,
                                        qty: itemProduct.qty,
                                        unitySymbol: itemProduct.unitySymbol,
                                        price: formaterDecimalBR(itemProduct.price),
                                        total: formaterDecimalBR(total),
                                        note: itemProduct.note,
                                    })
                                    grandTotal += parseFloat(total);
                                }
                                else {
                                    itemProduct.qty = '';
                                }
                            });
                        }
                        else {
                            
                            if (itemSubCategoryOrProduct.qty != null && itemSubCategoryOrProduct.qty != undefined && itemSubCategoryOrProduct.qty != "0.00" && itemSubCategoryOrProduct.qty != "" ) {

                                let qty = parseFloat(itemSubCategoryOrProduct.qty == '' ? 0 : itemSubCategoryOrProduct.qty);
                                    
                                let total = (qty * itemSubCategoryOrProduct.price).toFixed(2);

                                this.listProductSelecteds.push({
                                    id: itemSubCategoryOrProduct.idServiceItem,
                                    idService: this.id,
                                    idCategory: itemCategory.id,
                                    categoryDescription: itemCategory.name,
                                    idSubCategory: 0,
                                    subCategoryDescription: "",
                                    productDescription: itemSubCategoryOrProduct.name,
                                    idProduct: itemSubCategoryOrProduct.idTable,
                                    qty: itemSubCategoryOrProduct.qty,
                                    unitySymbol: itemSubCategoryOrProduct.unitySymbol,
                                    price: formaterDecimalBR(itemSubCategoryOrProduct.price),
                                    total: formaterDecimalBR(total),
                                    note: itemSubCategoryOrProduct.note,
                                })
                                grandTotal += parseFloat(total);
                            }
                            else {
                                itemSubCategoryOrProduct.qty = ''
                            }
                        }
                    });
                });

                let permitFeeValue = 0;
                if (this.serviceProjectResponse.permitFee > 0) {
                    permitFeeValue = grandTotal * (this.serviceProjectResponse.permitFee / 100);
                    grandTotal += permitFeeValue;
                }
                
                this.grandTotal = `$ ${formaterDecimalBR(((grandTotal * this.og) / this.og).toFixed(2))}`;
            },

            async cancel() {
                this.$router.push({ path: "/drafting/pipeline" });
            },

            async showItem(itemTitle, itemDescription) {
                this.itemTitle = itemTitle;
                this.itemReasonDescription = itemDescription;
                this.showDialogItemNote = true;
            },

            async saveItem() {

                this.showDialogItemNote = false;

                switch (this.itemTitle) {
                    case this.titles.serviceInformation: 
                        this.serviceDraftingRequest.serviceInformationNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.scopeOfWork: 
                        this.serviceDraftingRequest.scopeOfWorkNotes = this.itemReasonDescription; 
                    break;
                    
                    case this.titles.details: 
                        this.serviceDraftingRequest.detailsNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.dimensionedEquipmentLocation: 
                        this.serviceDraftingRequest.dimensionedEquipmentLocationNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.fenceEnclosureInformation: 
                        this.serviceDraftingRequest.fenceEnclosureInformationNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.fenceLocation: 
                        this.serviceDraftingRequest.fenceLocationNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.depthDeepestPointLocation: 
                        this.serviceDraftingRequest.depthDeepestPointLocationNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.lightLocations: 
                        this.serviceDraftingRequest.lightLocationsNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.soilTest: 
                        this.serviceDraftingRequest.soilTestNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.pergolas: 
                        this.serviceDraftingRequest.pergolasNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.waterFeatures: 
                        this.serviceDraftingRequest.waterFeaturesNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.bbq: 
                        this.serviceDraftingRequest.bbqNotes = this.itemReasonDescription; 
                    break;

                    case this.titles.propertyLineAndElements: 
                        this.serviceDraftingRequest.propertyLineAndElementsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.overallDimensionPoolDeck: 
                        this.serviceDraftingRequest.overallDimensionPoolDeckNotes = this.itemReasonDescription;
                    break;

                    case this.titles.setbackDimension: 
                        this.serviceDraftingRequest.setbackDimensionNotes = this.itemReasonDescription;
                    break;

                    case this.titles.shallowDeepEnd: 
                        this.serviceDraftingRequest.shallowDeepEndNotes = this.itemReasonDescription;
                    break;

                    case this.titles.allFeatures: 
                        this.serviceDraftingRequest.allFeaturesNotes = this.itemReasonDescription;
                    break;

                    case this.titles.theraphyJet: 
                        this.serviceDraftingRequest.theraphyJetNotes = this.itemReasonDescription;
                    break;

                    case this.titles.houseShownSingleLine: 
                        this.serviceDraftingRequest.houseShownSingleLineNotes = this.itemReasonDescription;
                    break;

                    case this.titles.contract: 
                        this.serviceDraftingRequest.contractNotes = this.itemReasonDescription;
                    break;

                    case this.titles.auditSheet: 
                        this.serviceDraftingRequest.auditSheetNotes = this.itemReasonDescription;
                    break;

                    case this.titles.surveySitePlan: 
                        this.serviceDraftingRequest.surveySitePlanNotes = this.itemReasonDescription;
                    break;

                    case this.titles.twoDrawings: 
                        this.serviceDraftingRequest.twoDrawingsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.threeRenderings: 
                        this.serviceDraftingRequest.threeRenderingsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.existingPictures: 
                        this.serviceDraftingRequest.existingPicturesNotes = this.itemReasonDescription;
                    break;

                    case this.titles.dxfInDxfGroup: 
                        this.serviceDraftingRequest.dxfInDxfGroupNotes = this.itemReasonDescription;
                    break;

                    case this.titles.jobReleaseForm: 
                        this.serviceDraftingRequest.jobReleaseFormNotes = this.itemReasonDescription;
                    break;

                    case this.titles.electricalLoadCalc: 
                        this.serviceDraftingRequest.electricalLoadCalcNotes = this.itemReasonDescription;
                    break;

                    case this.titles.lotCoverageForm: 
                        this.serviceDraftingRequest.lotCoverageFormNotes = this.itemReasonDescription;
                    break;

                    case this.titles.cadReleaseForm: 
                        this.serviceDraftingRequest.cadReleaseFormNotes = this.itemReasonDescription;
                    break;

                    case this.titles.soilReport: 
                        this.serviceDraftingRequest.soilReportNotes = this.itemReasonDescription;
                    break;

                    case this.titles.driverLicense: 
                        this.serviceDraftingRequest.driverLicenseNotes = this.itemReasonDescription;
                    break;

                    case this.titles.perimeterChargeInclude: 
                        this.serviceDraftingRequest.perimeterChargeIncludeNotes = this.itemReasonDescription;
                    break;

                    case this.titles.excavationChargeInclude: 
                        this.serviceDraftingRequest.excavationChargeIncludeNotes = this.itemReasonDescription;
                    break;

                    case this.titles.legible: 
                        this.serviceDraftingRequest.legibleNotes = this.itemReasonDescription;
                    break;

                    case this.titles.elevationShown: 
                        this.serviceDraftingRequest.elevationShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.treesShown: 
                        this.serviceDraftingRequest.treesShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.fenceAndGatesShown: 
                        this.serviceDraftingRequest.fenceAndGatesShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.overallDims: 
                        this.serviceDraftingRequest.overallDimsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.dimsFromPool: 
                        this.serviceDraftingRequest.dimsFromPoolNotes = this.itemReasonDescription;
                    break;

                    case this.titles.equipmentPadLocation: 
                        this.serviceDraftingRequest.equipmentPadLocationNotes = this.itemReasonDescription;
                    break;

                    case this.titles.shallowAndDeepEndShown: 
                        this.serviceDraftingRequest.shallowAndDeepEndShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.allLightsAreShown: 
                        this.serviceDraftingRequest.allLightsAreShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.allFeaturesAreShown: 
                        this.serviceDraftingRequest.allFeaturesAreShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.jetLocations: 
                        this.serviceDraftingRequest.jetLocationsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.landscapingAndFurnitureAreNotShown: 
                        this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.houseShownWithSingleLine: 
                        this.serviceDraftingRequest.houseShownWithSingleLineNotes = this.itemReasonDescription;
                    break;

                    case this.titles.isThereWaterLevelControl: 
                        this.serviceDraftingRequest.isThereWaterLevelControlNotes = this.itemReasonDescription;
                    break;

                    case this.titles.bbq3DRenderings: 
                        this.serviceDraftingRequest.bbq3DRenderingsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.bbqAppliancesShown: 
                        this.serviceDraftingRequest.bbqAppliancesShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.bbqNaturalPropaneGas: 
                        this.serviceDraftingRequest.bbqNaturalPropaneGasNotes = this.itemReasonDescription;
                    break;

                    case this.titles.bbqIsThereSink: 
                        this.serviceDraftingRequest.bbqIsThereSinkNotes = this.itemReasonDescription;
                    break;

                    case this.titles.bbqElectricalIsAtLeast6AwayFromWater: 
                        this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes = this.itemReasonDescription;
                    break;

                    case this.titles.pergolaOverallDims: 
                        this.serviceDraftingRequest.pergolaOverallDimsNotes = this.itemReasonDescription;
                    break;

                    case this.titles.pergolaLightsAndFansAreShown: 
                        this.serviceDraftingRequest.pergolaLightsAndFansAreShownNotes = this.itemReasonDescription;
                    break;

                    case this.titles.pergolaFanAre5AwayFromWater: 
                        this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes = this.itemReasonDescription;
                    break;

                    case this.titles.pergolaElectricalIs6AwayFromWater: 
                        this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes = this.itemReasonDescription;
                    break;
                }
                
            },

            async validateCheckItems() {

                let result = {
                    success: true,
                    anyItemDenied: false
                };

                if (this.serviceDraftingRequest.scopeOfWorkType == null || this.serviceDraftingRequest.scopeOfWorkType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.scopeOfWork}`);
                }
                else if (this.serviceDraftingRequest.scopeOfWorkType == 0 && 
                        (this.serviceDraftingRequest.scopeOfWorkNotes == null || 
                         this.serviceDraftingRequest.scopeOfWorkNotes == undefined || 
                         this.serviceDraftingRequest.scopeOfWorkNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.scopeOfWork} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.detailsType == null || this.serviceDraftingRequest.detailsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.details}`);
                }
                else if (this.serviceDraftingRequest.detailsType == 0 && 
                        (this.serviceDraftingRequest.detailsNotes == null || 
                         this.serviceDraftingRequest.detailsNotes == undefined || 
                         this.serviceDraftingRequest.detailsNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.details} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.dimensionedEquipmentLocationType == null || this.serviceDraftingRequest.dimensionedEquipmentLocationType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.dimensionedEquipmentLocation}`);
                }
                else if (this.serviceDraftingRequest.dimensionedEquipmentLocationType == 0 && 
                        (this.serviceDraftingRequest.dimensionedEquipmentLocationNotes == null || 
                         this.serviceDraftingRequest.dimensionedEquipmentLocationNotes == undefined || 
                         this.serviceDraftingRequest.dimensionedEquipmentLocationNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.dimensionedEquipmentLocation} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.fenceEnclosureInformationType == null || this.serviceDraftingRequest.fenceEnclosureInformationType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.fenceEnclosureInformation}`);
                }
                else if (this.serviceDraftingRequest.fenceEnclosureInformationType == 0 && 
                        (this.serviceDraftingRequest.fenceEnclosureInformationNotes == null || 
                         this.serviceDraftingRequest.fenceEnclosureInformationNotes == undefined || 
                         this.serviceDraftingRequest.fenceEnclosureInformationNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.fenceEnclosureInformation} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.fenceLocationType == null || this.serviceDraftingRequest.fenceLocationType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.fenceLocation}`);
                }
                else if (this.serviceDraftingRequest.fenceLocationType == 0 && 
                        (this.serviceDraftingRequest.fenceLocationNotes == null || 
                         this.serviceDraftingRequest.fenceLocationNotes == undefined || 
                         this.serviceDraftingRequest.fenceLocationNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.fenceLocation} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.depthDeepestPointLocationType == null || this.serviceDraftingRequest.depthDeepestPointLocationType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.depthDeepestPointLocation}`);
                }
                else if (this.serviceDraftingRequest.depthDeepestPointLocationType == 0 && 
                        (this.serviceDraftingRequest.depthDeepestPointLocationNotes == null || 
                         this.serviceDraftingRequest.depthDeepestPointLocationNotes == undefined || 
                         this.serviceDraftingRequest.depthDeepestPointLocationNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.depthDeepestPointLocation} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.lightLocationsType == null || this.serviceDraftingRequest.lightLocationsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.lightLocations}`);
                }
                else if (this.serviceDraftingRequest.lightLocationsType == 0 && 
                        (this.serviceDraftingRequest.lightLocationsNotes == null || 
                         this.serviceDraftingRequest.lightLocationsNotes == undefined || 
                         this.serviceDraftingRequest.lightLocationsNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.lightLocations} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.soilTestType == null || this.serviceDraftingRequest.soilTestType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.soilTest}`);
                }
                else if (this.serviceDraftingRequest.soilTestType == 0 && 
                        (this.serviceDraftingRequest.soilTestNotes == null || 
                         this.serviceDraftingRequest.soilTestNotes == undefined || 
                         this.serviceDraftingRequest.soilTestNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.soilTest} and must provide a reason.`);
                }

                else if (this.isProjectPergola == true && (this.serviceDraftingRequest.pergolasType == null || this.serviceDraftingRequest.pergolasType == undefined)) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.pergolas}`);
                }
                else if (this.isProjectPergola == true &&
                         this.serviceDraftingRequest.pergolasType == 0 && 
                        (this.serviceDraftingRequest.pergolasNotes == null || 
                         this.serviceDraftingRequest.pergolasNotes == undefined || 
                         this.serviceDraftingRequest.pergolasNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.pergolas} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.waterFeaturesType == null || this.serviceDraftingRequest.waterFeaturesType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.waterFeatures}`);
                }
                else if (this.serviceDraftingRequest.waterFeaturesType == 0 && 
                        (this.serviceDraftingRequest.waterFeaturesNotes == null || 
                         this.serviceDraftingRequest.waterFeaturesNotes == undefined || 
                         this.serviceDraftingRequest.waterFeaturesNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.waterFeatures} and must provide a reason.`);
                }

                else if (this.isProjectBBQ == true && (this.serviceDraftingRequest.bbqType == null || this.serviceDraftingRequest.bbqType == undefined)) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbq}`);
                }
                else if (this.isProjectBBQ == true &&
                         this.serviceDraftingRequest.bbqType == 0 && 
                        (this.serviceDraftingRequest.bbqNotes == null || 
                         this.serviceDraftingRequest.bbqNotes == undefined || 
                         this.serviceDraftingRequest.bbqNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbq} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.propertyLineAndElementsType == null || this.serviceDraftingRequest.propertyLineAndElementsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.CC}`);
                }
                else if (this.serviceDraftingRequest.propertyLineAndElementsType == 0 && 
                        (this.serviceDraftingRequest.propertyLineAndElementsNotes == null || 
                         this.serviceDraftingRequest.propertyLineAndElementsNotes == undefined || 
                         this.serviceDraftingRequest.propertyLineAndElementsNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.propertyLineAndElements} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.overallDimensionPoolDeckType == null || this.serviceDraftingRequest.overallDimensionPoolDeckType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.overallDimensionPoolDeck}`);
                }
                else if (this.serviceDraftingRequest.overallDimensionPoolDeckType == 0 && 
                        (this.serviceDraftingRequest.overallDimensionPoolDeckNotes == null || 
                         this.serviceDraftingRequest.overallDimensionPoolDeckNotes == undefined || 
                         this.serviceDraftingRequest.overallDimensionPoolDeckNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.overallDimensionPoolDeck} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.setbackDimensionType == null || this.serviceDraftingRequest.setbackDimensionType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.setbackDimension}`);
                }
                else if (this.serviceDraftingRequest.setbackDimensionType == 0 && 
                        (this.serviceDraftingRequest.setbackDimensionNotes == null || 
                         this.serviceDraftingRequest.setbackDimensionNotes == undefined || 
                         this.serviceDraftingRequest.setbackDimensionNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.setbackDimension} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.shallowDeepEndType == null || this.serviceDraftingRequest.shallowDeepEndType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.shallowDeepEnd}`);
                }
                else if (this.serviceDraftingRequest.shallowDeepEndType == 0 && 
                        (this.serviceDraftingRequest.shallowDeepEndNotes == null || 
                         this.serviceDraftingRequest.shallowDeepEndNotes == undefined || 
                         this.serviceDraftingRequest.shallowDeepEndNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.shallowDeepEnd} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.allFeaturesType == null || this.serviceDraftingRequest.allFeaturesType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.allFeatures}`);
                }
                else if (this.serviceDraftingRequest.allFeaturesType == 0 && 
                        (this.serviceDraftingRequest.allFeaturesNotes == null || 
                         this.serviceDraftingRequest.allFeaturesNotes == undefined || 
                         this.serviceDraftingRequest.allFeaturesNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.allFeatures} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.theraphyJetType == null || this.serviceDraftingRequest.theraphyJetType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.theraphyJet}`);
                }
                else if (this.serviceDraftingRequest.theraphyJetType == 0 && 
                        (this.serviceDraftingRequest.theraphyJetNotes == null || 
                         this.serviceDraftingRequest.theraphyJetNotes == undefined || 
                         this.serviceDraftingRequest.theraphyJetNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.theraphyJet} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.houseShownSingleLineType == null || this.serviceDraftingRequest.houseShownSingleLineType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.houseShownSingleLine}`);
                }
                else if (this.serviceDraftingRequest.houseShownSingleLineType == 0 && 
                        (this.serviceDraftingRequest.houseShownSingleLineNotes == null || 
                         this.serviceDraftingRequest.houseShownSingleLineNotes == undefined || 
                         this.serviceDraftingRequest.houseShownSingleLineNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.houseShownSingleLine} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.contractType == null || this.serviceDraftingRequest.contractType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.contract}`);
                }
                else if (this.serviceDraftingRequest.contractType == 0 && 
                        (this.serviceDraftingRequest.contractNotes == null || 
                         this.serviceDraftingRequest.contractNotes == undefined || 
                         this.serviceDraftingRequest.contractNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.contract} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.auditSheetType == null || this.serviceDraftingRequest.auditSheetType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.auditSheet}`);
                }
                else if (this.serviceDraftingRequest.auditSheetType == 0 && 
                        (this.serviceDraftingRequest.auditSheetNotes == null || 
                         this.serviceDraftingRequest.auditSheetNotes == undefined || 
                         this.serviceDraftingRequest.auditSheetNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.auditSheet} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.surveySitePlanType == null || this.serviceDraftingRequest.surveySitePlanType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.surveySitePlan}`);
                }
                else if (this.serviceDraftingRequest.surveySitePlanType == 0 && 
                        (this.serviceDraftingRequest.surveySitePlanNotes == null || 
                         this.serviceDraftingRequest.surveySitePlanNotes == undefined || 
                         this.serviceDraftingRequest.surveySitePlanNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.surveySitePlan} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.twoDrawingsType == null || this.serviceDraftingRequest.twoDrawingsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.twoDrawings}`);
                }
                else if (this.serviceDraftingRequest.twoDrawingsType == 0 && 
                        (this.serviceDraftingRequest.twoDrawingsNotes == null || 
                         this.serviceDraftingRequest.twoDrawingsNotes == undefined || 
                         this.serviceDraftingRequest.twoDrawingsNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.twoDrawings} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.threeRenderingsType == null || this.serviceDraftingRequest.threeRenderingsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.threeRenderings}`);
                }
                else if (this.serviceDraftingRequest.threeRenderingsType == 0 && 
                        (this.serviceDraftingRequest.threeRenderingsNotes == null || 
                         this.serviceDraftingRequest.threeRenderingsNotes == undefined || 
                         this.serviceDraftingRequest.threeRenderingsNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.threeRenderings} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.existingPicturesType == null || this.serviceDraftingRequest.existingPicturesType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.existingPictures}`);
                }
                else if (this.serviceDraftingRequest.existingPicturesType == 0 && 
                        (this.serviceDraftingRequest.existingPicturesNotes == null || 
                         this.serviceDraftingRequest.existingPicturesNotes == undefined || 
                         this.serviceDraftingRequest.existingPicturesNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.existingPictures} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.dxfInDxfGroupType == null || this.serviceDraftingRequest.dxfInDxfGroupType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.dxfInDxfGroup}`);
                }
                else if (this.serviceDraftingRequest.dxfInDxfGroupType == 0 && 
                        (this.serviceDraftingRequest.dxfInDxfGroupNotes == null || 
                         this.serviceDraftingRequest.dxfInDxfGroupNotes == undefined || 
                         this.serviceDraftingRequest.dxfInDxfGroupNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.dxfInDxfGroup} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.jobReleaseFormType == null || this.serviceDraftingRequest.jobReleaseFormType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.jobReleaseForm}`);
                }
                else if (this.serviceDraftingRequest.jobReleaseFormType == 0 && 
                        (this.serviceDraftingRequest.jobReleaseFormNotes == null || 
                         this.serviceDraftingRequest.jobReleaseFormNotes == undefined || 
                         this.serviceDraftingRequest.jobReleaseFormNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.jobReleaseForm} and must provide a reason.`);
                }
                else if (this.serviceDraftingRequest.electricalLoadCalcType == null || this.serviceDraftingRequest.electricalLoadCalcType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.electricalLoadCalc}`);
                }
                else if (this.serviceDraftingRequest.electricalLoadCalcType == 0 && 
                        (this.serviceDraftingRequest.electricalLoadCalcNotes == null || 
                         this.serviceDraftingRequest.electricalLoadCalcNotes == undefined || 
                         this.serviceDraftingRequest.electricalLoadCalcNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.electricalLoadCalc} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.lotCoverageFormType == null || this.serviceDraftingRequest.lotCoverageFormType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.lotCoverageForm}`);
                }
                else if (this.serviceDraftingRequest.lotCoverageFormType == 0 && 
                        (this.serviceDraftingRequest.lotCoverageFormNotes == null || 
                         this.serviceDraftingRequest.lotCoverageFormNotes == undefined || 
                         this.serviceDraftingRequest.lotCoverageFormNotes.toString().trim() == ''))  {

                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.lotCoverageForm} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.cadReleaseFormType == null || this.serviceDraftingRequest.cadReleaseFormType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.cadReleaseForm}`);
                }
                else if (this.serviceDraftingRequest.cadReleaseFormType == 0 && 
                        (this.serviceDraftingRequest.cadReleaseFormNotes == null || 
                         this.serviceDraftingRequest.cadReleaseFormNotes == undefined || 
                         this.serviceDraftingRequest.cadReleaseFormNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.cadReleaseForm} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.soilReportType == null || this.serviceDraftingRequest.soilReportType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.soilReport}`);
                }
                else if (this.serviceDraftingRequest.soilReportType == 0 && 
                        (this.serviceDraftingRequest.soilReportNotes == null || 
                         this.serviceDraftingRequest.soilReportNotes == undefined || 
                         this.serviceDraftingRequest.soilReportNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.soilReport} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.driverLicenseType == null || this.serviceDraftingRequest.driverLicenseType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.driverLicense}`);
                }
                else if (this.serviceDraftingRequest.driverLicenseType == 0 && 
                        (this.serviceDraftingRequest.driverLicenseNotes == null || 
                         this.serviceDraftingRequest.driverLicenseNotes == undefined || 
                         this.serviceDraftingRequest.driverLicenseNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.driverLicense} and must provide a reason.`);
                }
                
                else if (this.serviceDraftingRequest.perimeterChargeIncludeType == null || this.serviceDraftingRequest.perimeterChargeIncludeType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.perimeterChargeInclude}`);
                }
                else if (this.serviceDraftingRequest.perimeterChargeIncludeType == 0 && 
                        (this.serviceDraftingRequest.perimeterChargeIncludeNotes == null || 
                         this.serviceDraftingRequest.perimeterChargeIncludeNotes == undefined || 
                         this.serviceDraftingRequest.perimeterChargeIncludeNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.perimeterChargeInclude} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.legibleType == null || this.serviceDraftingRequest.legibleType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.legible}`);
                }
                else if (this.serviceDraftingRequest.legibleType == 0 && 
                        (this.serviceDraftingRequest.legibleNotes == null || 
                         this.serviceDraftingRequest.legibleNotes == undefined || 
                         this.serviceDraftingRequest.legibleNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.legible} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.elevationShownType == null || this.serviceDraftingRequest.elevationShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.elevationShown}`);
                }
                else if (this.serviceDraftingRequest.elevationShownType == 0 && 
                        (this.serviceDraftingRequest.elevationShownNotes == null || 
                         this.serviceDraftingRequest.elevationShownNotes == undefined || 
                         this.serviceDraftingRequest.elevationShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.elevationShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.treesShownType == null || this.serviceDraftingRequest.treesShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.treesShown}`);
                }
                else if (this.serviceDraftingRequest.treesShownType == 0 && 
                        (this.serviceDraftingRequest.treesShownNotes == null || 
                         this.serviceDraftingRequest.treesShownNotes == undefined || 
                         this.serviceDraftingRequest.treesShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.treesShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.fenceAndGatesShownType == null || this.serviceDraftingRequest.fenceAndGatesShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.fenceAndGatesShown}`);
                }
                else if (this.serviceDraftingRequest.fenceAndGatesShownType == 0 && 
                        (this.serviceDraftingRequest.fenceAndGatesShownNotes == null || 
                         this.serviceDraftingRequest.fenceAndGatesShownNotes == undefined || 
                         this.serviceDraftingRequest.fenceAndGatesShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.fenceAndGatesShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.overallDimsType == null || this.serviceDraftingRequest.overallDimsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.overallDims}`);
                }
                else if (this.serviceDraftingRequest.overallDimsType == 0 && 
                        (this.serviceDraftingRequest.overallDimsNotes == null || 
                         this.serviceDraftingRequest.overallDimsNotes == undefined || 
                         this.serviceDraftingRequest.overallDimsNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.overallDims} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.dimsFromPoolType == null || this.serviceDraftingRequest.dimsFromPoolType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.dimsFromPool}`);
                }
                else if (this.serviceDraftingRequest.dimsFromPoolType == 0 && 
                        (this.serviceDraftingRequest.dimsFromPoolNotes == null || 
                         this.serviceDraftingRequest.dimsFromPoolNotes == undefined || 
                         this.serviceDraftingRequest.dimsFromPoolNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.dimsFromPool} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.equipmentPadLocationType == null || this.serviceDraftingRequest.equipmentPadLocationType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.equipmentPadLocation}`);
                }
                else if (this.serviceDraftingRequest.equipmentPadLocationType == 0 && 
                        (this.serviceDraftingRequest.equipmentPadLocationNotes == null || 
                         this.serviceDraftingRequest.equipmentPadLocationNotes == undefined || 
                         this.serviceDraftingRequest.equipmentPadLocationNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.equipmentPadLocation} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.shallowAndDeepEndShownType == null || this.serviceDraftingRequest.shallowAndDeepEndShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.shallowAndDeepEndShown}`);
                }
                else if (this.serviceDraftingRequest.shallowAndDeepEndShownType == 0 && 
                        (this.serviceDraftingRequest.shallowAndDeepEndShownNotes == null || 
                         this.serviceDraftingRequest.shallowAndDeepEndShownNotes == undefined || 
                         this.serviceDraftingRequest.shallowAndDeepEndShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.shallowAndDeepEndShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.allLightsAreShownType == null || this.serviceDraftingRequest.allLightsAreShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.allLightsAreShown}`);
                }
                else if (this.serviceDraftingRequest.allLightsAreShownType == 0 && 
                        (this.serviceDraftingRequest.allLightsAreShownNotes == null || 
                         this.serviceDraftingRequest.allLightsAreShownNotes == undefined || 
                         this.serviceDraftingRequest.allLightsAreShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.allLightsAreShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.allFeaturesAreShownType == null || this.serviceDraftingRequest.allFeaturesAreShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.allFeaturesAreShown}`);
                }
                else if (this.serviceDraftingRequest.allFeaturesAreShownType == 0 && 
                        (this.serviceDraftingRequest.allFeaturesAreShownNotes == null || 
                         this.serviceDraftingRequest.allFeaturesAreShownNotes == undefined || 
                         this.serviceDraftingRequest.allFeaturesAreShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.allFeaturesAreShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.jetLocationsType == null || this.serviceDraftingRequest.jetLocationsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.jetLocations}`);
                }
                else if (this.serviceDraftingRequest.jetLocationsType == 0 && 
                        (this.serviceDraftingRequest.jetLocationsNotes == null || 
                         this.serviceDraftingRequest.jetLocationsNotes == undefined || 
                         this.serviceDraftingRequest.jetLocationsNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.jetLocations} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownType == null || this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.landscapingAndFurnitureAreNotShown}`);
                }
                else if (this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownType == 0 && 
                        (this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes == null || 
                         this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes == undefined || 
                         this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.landscapingAndFurnitureAreNotShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.houseShownWithSingleLineType == null || this.serviceDraftingRequest.houseShownWithSingleLineType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.houseShownWithSingleLine}`);
                }
                else if (this.serviceDraftingRequest.houseShownWithSingleLineType == 0 && 
                        (this.serviceDraftingRequest.houseShownWithSingleLineNotes == null || 
                         this.serviceDraftingRequest.houseShownWithSingleLineNotes == undefined || 
                         this.serviceDraftingRequest.houseShownWithSingleLineNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.houseShownWithSingleLine} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.isThereWaterLevelControlType == null || this.serviceDraftingRequest.isThereWaterLevelControlType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.isThereWaterLevelControl}`);
                }
                else if (this.serviceDraftingRequest.isThereWaterLevelControlType == 0 && 
                        (this.serviceDraftingRequest.isThereWaterLevelControlNotes == null || 
                         this.serviceDraftingRequest.isThereWaterLevelControlNotes == undefined || 
                         this.serviceDraftingRequest.isThereWaterLevelControlNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.isThereWaterLevelControl} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.bbq3DRenderingsType == null || this.serviceDraftingRequest.bbq3DRenderingsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbq3DRenderings}`);
                }
                else if (this.serviceDraftingRequest.bbq3DRenderingsType == 0 && 
                        (this.serviceDraftingRequest.bbq3DRenderingsNotes == null || 
                         this.serviceDraftingRequest.bbq3DRenderingsNotes == undefined || 
                         this.serviceDraftingRequest.bbq3DRenderingsNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbq3DRenderings} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.bbqAppliancesShownType == null || this.serviceDraftingRequest.bbqAppliancesShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbqAppliancesShown}`);
                }
                else if (this.serviceDraftingRequest.bbqAppliancesShownType == 0 && 
                        (this.serviceDraftingRequest.bbqAppliancesShownNotes == null || 
                         this.serviceDraftingRequest.bbqAppliancesShownNotes == undefined || 
                         this.serviceDraftingRequest.bbqAppliancesShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbqAppliancesShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.bbqNaturalPropaneGasType == null || this.serviceDraftingRequest.bbqNaturalPropaneGasType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbqNaturalPropaneGas}`);
                }
                else if (this.serviceDraftingRequest.bbqNaturalPropaneGasType == 0 && 
                        (this.serviceDraftingRequest.bbqNaturalPropaneGasNotes == null || 
                         this.serviceDraftingRequest.bbqNaturalPropaneGasNotes == undefined || 
                         this.serviceDraftingRequest.bbqNaturalPropaneGasNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbqNaturalPropaneGas} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.bbqIsThereSinkType == null || this.serviceDraftingRequest.bbqIsThereSinkType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbqIsThereSink}`);
                }
                else if (this.serviceDraftingRequest.bbqIsThereSinkType == 0 && 
                        (this.serviceDraftingRequest.bbqIsThereSinkNotes == null || 
                         this.serviceDraftingRequest.bbqIsThereSinkNotes == undefined || 
                         this.serviceDraftingRequest.bbqIsThereSinkNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbqIsThereSink} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType == null || this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.bbqElectricalIsAtLeast6AwayFromWater}`);
                }
                else if (this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType == 0 && 
                        (this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes == null || 
                         this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes == undefined || 
                         this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.bbqElectricalIsAtLeast6AwayFromWater} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.pergolaOverallDimsType == null || this.serviceDraftingRequest.pergolaOverallDimsType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.pergolaOverallDims}`);
                }
                else if (this.serviceDraftingRequest.pergolaOverallDimsType == 0 && 
                        (this.serviceDraftingRequest.pergolaOverallDimsNotes == null || 
                         this.serviceDraftingRequest.pergolaOverallDimsNotes == undefined || 
                         this.serviceDraftingRequest.pergolaOverallDimsNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.pergolaOverallDims} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.pergolaLightsAndFansAreShownType == null || this.serviceDraftingRequest.pergolaLightsAndFansAreShownType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.pergolaLightsAndFansAreShown}`);
                }
                else if (this.serviceDraftingRequest.pergolaLightsAndFansAreShownType == 0 && 
                        (this.serviceDraftingRequest.pergolaLightsAndFansAreShownNotes == null || 
                         this.serviceDraftingRequest.pergolaLightsAndFansAreShownNotes == undefined || 
                         this.serviceDraftingRequest.pergolaLightsAndFansAreShownNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.pergolaLightsAndFansAreShown} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterType == null || this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.pergolaFanAre5AwayFromWater}`);
                }
                else if (this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterType == 0 && 
                        (this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes == null || 
                         this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes == undefined || 
                         this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.pergolaFanAre5AwayFromWater} and must provide a reason.`);
                }

                else if (this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType == null || this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType == undefined) {
                    result.success = false;
                    this.showToast("error", "Warning!", `You must select APPROVED or DENIED in ${this.titles.pergolaElectricalIs6AwayFromWater}`);
                }
                else if (this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType == 0 && 
                        (this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes == null || 
                         this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes == undefined || 
                         this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterNotes.toString().trim() == ''))  {
                    result.success = false;
                    result.anyItemDenied = true;
                    this.showToast("error", "Warning!", `You denied ${this.titles.pergolaElectricalIs6AwayFromWater} and must provide a reason.`);
                }

                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.scopeOfWorkType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.detailsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.dimensionedEquipmentLocationType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.fenceEnclosureInformationType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.fenceLocationType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.depthDeepestPointLocationType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.lightLocationsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.soilTestType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.pergolasType == 0 && this.isProjectPergola == true : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.waterFeaturesType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbqType == 0 && this.isProjectBBQ == true : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.propertyLineAndElementsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.overallDimensionPoolDeckType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.setbackDimensionType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.shallowDeepEndType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.allFeaturesType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.theraphyJetType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.houseShownSingleLineType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.contractType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.auditSheetType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.surveySitePlanType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.twoDrawingsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.threeRenderingsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.existingPicturesType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.dxfInDxfGroupType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.jobReleaseFormType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.electricalLoadCalcType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.lotCoverageFormType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.cadReleaseFormType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.soilReportType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.driverLicenseType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.perimeterChargeIncludeType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.excavationChargeIncludeType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.legibleType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.elevationShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.treesShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.fenceAndGatesShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.overallDimsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.dimsFromPoolType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.equipmentPadLocationType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.shallowAndDeepEndShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.allLightsAreShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.allFeaturesAreShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.jetLocationsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.landscapingAndFurnitureAreNotShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.houseShownWithSingleLineType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.isThereWaterLevelControlType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbq3DRenderingsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbqAppliancesShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbqNaturalPropaneGasType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbqIsThereSinkType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.bbqElectricalIsAtLeast6AwayFromWaterType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.pergolaOverallDimsType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.pergolaLightsAndFansAreShownType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.pergolaFanAre5AwayFromWaterType == 0 : result.anyItemDenied;
                result.anyItemDenied = result.anyItemDenied == false ? this.serviceDraftingRequest.pergolaElectricalIs6AwayFromWaterType == 0 : result.anyItemDenied;

                return result;
            },

            async validateAndFinishDrafting() {

                let result = {
                    success: true,
                    anyItemDenied: false
                };

                if (this.steps == 1) {
                    result = await this.validateCheckItems();
                }

                this.statusService = this.PROJECT_STATUS.DRAFTING.id;

                if (result.success)
                {
                    let drafterTeamOK = true;

                    if (this.steps == 2) {
                        if (this.drafterTeam == null || this.drafterTeam == undefined || this.drafterTeam == "" || this.drafterTeam.length <= 0) {
                            this.showToast("error", "Warning!", `You must select at least one drafter!`);
                            drafterTeamOK = false;
                        }
                    }
                    
                    if (drafterTeamOK)
                    {
                        let msgConfirmation = "You have approved all items, confirm your decision?";

                        if (result.anyItemDenied) {
                            this.statusService = this.PROJECT_STATUS.SALES_CONTRACTED.id;
                            msgConfirmation = `You have denied one or more items and the service will go back to sales person to check, confirm your decision?`;
                        }

                        this.dialog = {
                            show: true,
                            headerText: 'Confirmation',
                            bodyText: msgConfirmation,
                            methodConfirm: this.finishDrafting,
                            params: 0
                        };
                    }
                }
            },

            async finishDrafting() {

                let result = {
                    success: true
                }

                if (this.steps == 2) {
                    
                    const listAllTeamsSelected = [
                        {
                            categoryTeam: CATEGORY_TEAM.DRAFTER.value,
                            listTeamSelected: [...this.drafterTeam],
                            nameOther: null,
                            list: [...this.listDrafters]
                        },

                        {
                            categoryTeam: CATEGORY_TEAM.PERMITTECH.value,
                            listTeamSelected: [...this.permitTeam],
                            nameOther: null,
                            list: [...this.listPermit]
                        },

                        {
                            categoryTeam: CATEGORY_TEAM.ELECTRICTECH.value,
                            listTeamSelected: [...this.electricTeam],
                            nameOther: this.electricTeamOtherName,
                            list: [...this.listElectricTech] 
                        },

                        {
                            categoryTeam: CATEGORY_TEAM.PLUMBINGTECH.value,
                            listTeamSelected: [...this.plumbingTeam],
                            nameOther: this.plumbingTeamOtherName,
                            list: [...this.listPlumbingTech]
                        },

                        {
                            categoryTeam: CATEGORY_TEAM.GASTECH.value,
                            listTeamSelected: [...this.gasTeam],
                            nameOther: this.gasTeamOtherName,
                            list: [...this.listGasTech] 
                        },

                        {
                            categoryTeam: CATEGORY_TEAM.ENGINEER.value,
                            listTeamSelected: [...this.engineerTeam],
                            nameOther: this.engineerTeamOtherName,
                            list: [...this.listEngineerTech] 
                        },
                    ]

                    let listTeamRequest = [];

                    await listAllTeamsSelected.forEach(async itemTeamSelected => {

                        await itemTeamSelected.listTeamSelected.forEach(async itemTeam => {

                            const categoryTeam = itemTeamSelected.categoryTeam;
                            const idUserOrContractor = itemTeamSelected.list[itemTeam].id;
                            let nameOther = null;
                            if (idUserOrContractor == -1) {
                                nameOther = itemTeamSelected.nameOther
                            }

                            listTeamRequest.push({
                                id: 0,
                                idServiceProject: this.id,
                                categoryTeam,
                                idUserOrContractor,
                                nameOther
                            });
                        });
                    })

                    result = await this.$store.dispatch("serviceModule/AssignTeam", listTeamRequest);
                }

                if (result.success) {

                    const updateStatusRequest = {
                        id: this.id,
                        status: this.statusService,  //Drafting
                        statusPermitting: this.PROJECT_STATUS.PERMITTING_PLAN_APPROVAL_PENDING.id //Approvals
                    };

                    const result = await this.$store.dispatch("serviceModule/UpdateProjectStatus", updateStatusRequest);

                    if (result.success) {
                        this.showToast("success", "Success!", "Saved with successfully");
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Error!", result.message);
                    }
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

            },

            async saveDrafting() {
                
                this.showLoading();

                this.serviceDraftingRequest.idServiceProject = this.id;
                this.serviceDraftingRequest.serviceInformationType = 1;

                const resultValidate = await this.validateCheckItems();

                if (!resultValidate.success) {
                    this.hideLoading();
                    return;
                }

                this.$store.dispatch("serviceModule/CreateUpdateDrafting", this.serviceDraftingRequest);

                if (resultValidate.success && resultValidate.anyItemDenied) {
                    this.statusService = 7;
                    const msgConfirmation = `You have denied one or more items and the service will go back to sales person to check, confirm your decision?`;

                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: msgConfirmation,
                        methodConfirm: this.finishDrafting,
                        params: 0
                    };
                }
                else if (resultValidate.success) {

                    this.showToast("success", "Success!", "Drafting saved with successfully!");
                    await this.listAvailableTechs();
                    this.steps = 2;

                    this.getRegister();
                }
                else {
                    this.showToast("error", "Warning!", "Error to save drafting!");
                }

                this.hideLoading();
            },

            async listAvailableTechs() {
                this.listDrafters = await this.$store.dispatch("serviceModule/ListAvaliableDrafters");
                this.listPermit = await this.$store.dispatch("serviceModule/ListAvaliablePermitters");
                
                const listContractors = await this.$store.dispatch("contractorModule/List");

                const otherOption = {
                    id: -1,
                    name: "Other"
                }

                this.listElectricTech = listContractors.filter(item => item.idContractorCategory == CONTRACTOR_CATEGORY.Electric.value);
                this.listPlumbingTech = listContractors.filter(item => item.idContractorCategory == CONTRACTOR_CATEGORY.Plumbing.value);
                this.listGasTech = listContractors.filter(item => item.idContractorCategory == CONTRACTOR_CATEGORY.Gas.value);
                this.listEngineerTech = listContractors.filter(item => item.idContractorCategory == CONTRACTOR_CATEGORY.Engineer.value);

                this.listElectricTech.push(otherOption);
                this.listPlumbingTech.push(otherOption);
                this.listGasTech.push(otherOption);
                this.listEngineerTech.push(otherOption);
            },
        },

        async created() {

            this.showLoading();

            await this.getLists();
            await this.getRegister();

            this.hideLoading();
        }
    })
</script>

<style scoped>
    .v-btn {
        height: 45px !important;
        width: 150px;
    }

    .imageFileName {
        font-size: 10px; 
        margin-left: 5px;
    }

    .btnToogleNA {
        background-color: transparent !important;
        color: var(--color__main) !important;
    }

</style>